'use strict';

var fontListJson = [
	{
		name: "DTLArgoT",
		fontFile: "A057013T",
		family: "DTLArgoT",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/A057013T.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/A057013T.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "DTLArgoT",
		fontFile: "A057016T",
		family: "DTLArgoT",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/A057016T.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/A057016T.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "DTLArgoT",
		fontFile: "A057033T",
		family: "DTLArgoT",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/A057033T.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/A057033T.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Aaux ProRegular OSF",
		fontFile: "AauxPro-RegularOSF",
		family: "Aaux ProRegular OSF",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/AauxPro-RegularOSF.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/AauxPro-RegularOSF.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Abadi MT Condensed Extra Bold",
		fontFile: "Abadi-MT-Condensed-Extra-Bold",
		family: "Abadi MT Condensed Extra Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Abadi-MT-Condensed-Extra-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Abadi-MT-Condensed-Extra-Bold.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Abadi MT Condensed Light",
		fontFile: "Abadi-MT-Condensed-Light",
		family: "Abadi MT Condensed Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Abadi-MT-Condensed-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Abadi-MT-Condensed-Light.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "ABeeZee",
		fontFile: "ABeeZee-Regular",
		family: "ABeeZee",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/ABeeZee-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/ABeeZee-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Abel",
		fontFile: "Abel-Regular",
		family: "Abel",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Abel-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Abel-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Abril Fatface",
		fontFile: "AbrilFatface-Regular",
		family: "Abril Fatface",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/AbrilFatface-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/AbrilFatface-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Adobe Caslon Pro",
		fontFile: "ACaslonPro-Italic",
		family: "Adobe Caslon Pro",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/ACaslonPro-Italic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/ACaslonPro-Italic.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			54,
			55
		]
	},
	{
		name: "Advent Pro",
		fontFile: "AdventPro-Bold",
		family: "Advent Pro",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/AdventPro-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/AdventPro-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7
		]
	},
	{
		name: "Advent Pro",
		fontFile: "AdventPro-Regular",
		family: "Advent Pro",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/AdventPro-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/AdventPro-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7
		]
	},
	{
		name: "Advent Pro",
		fontFile: "AdventPro-Thin",
		family: "Advent Pro Thin",
		weight: "Thin",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/AdventPro-Thin.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/AdventPro-Thin.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7
		]
	},
	{
		name: "Agfa Rotis Sans Serif",
		fontFile: "AgfaRotisSansSerif",
		family: "Agfa Rotis Sans Serif",
		weight: "Medium",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/AgfaRotisSansSerif.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/AgfaRotisSansSerif.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Aguafina Script",
		fontFile: "AguafinaScript-Regular",
		family: "Aguafina Script",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/AguafinaScript-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/AguafinaScript-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Berthold Akzidenz Grotesk BE",
		fontFile: "AkzidenzGroteskBE-Md",
		family: "Berthold Akzidenz Grotesk BE",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/AkzidenzGroteskBE-Md.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/AkzidenzGroteskBE-Md.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Alef",
		fontFile: "Alef-Bold",
		family: "Alef",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Alef-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Alef-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			11,
			54,
			111
		]
	},
	{
		name: "Alef",
		fontFile: "Alef-Regular",
		family: "Alef",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Alef-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Alef-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			11,
			54,
			111
		]
	},
	{
		name: "Alegreya",
		fontFile: "Alegreya-Bold",
		family: "Alegreya",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Alegreya-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Alegreya-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			7,
			8,
			52,
			53,
			54,
			55,
			56
		]
	},
	{
		name: "Alegreya",
		fontFile: "Alegreya-Italic",
		family: "Alegreya",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Alegreya-Italic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Alegreya-Italic.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			7,
			8,
			52,
			53,
			54,
			55,
			56
		]
	},
	{
		name: "Alegreya",
		fontFile: "Alegreya-Regular",
		family: "Alegreya",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Alegreya-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Alegreya-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			7,
			8,
			52,
			53,
			54,
			55,
			56
		]
	},
	{
		name: "Alegreya Sans SC",
		fontFile: "AlegreyaSansSC-Regular",
		family: "Alegreya Sans SC",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/AlegreyaSansSC-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/AlegreyaSansSC-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			52,
			54
		]
	},
	{
		name: "Alfa Slab One",
		fontFile: "AlfaSlabOne-Regular",
		family: "Alfa Slab One",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/AlfaSlabOne-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/AlfaSlabOne-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Allerta Stencil",
		fontFile: "AllertaStencil-Regular",
		family: "Allerta Stencil",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/AllertaStencil-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/AllertaStencil-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Allexis",
		fontFile: "Allexis",
		family: "Allexis",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Allexis.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Allexis.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Allexis Wide",
		fontFile: "AllexisWide",
		family: "Allexis Wide",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/AllexisWide.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/AllexisWide.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Allura",
		fontFile: "Allura-Regular",
		family: "Allura",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Allura-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Allura-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			6,
			52,
			54,
			56
		]
	},
	{
		name: "Amaranth",
		fontFile: "Amaranth-Bold",
		family: "Amaranth",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Amaranth-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Amaranth-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Amaranth",
		fontFile: "Amaranth-Regular",
		family: "Amaranth",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Amaranth-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Amaranth-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Amatic SC",
		fontFile: "AmaticSC-Regular",
		family: "Amatic SC",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/AmaticSC-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/AmaticSC-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Amiko",
		fontFile: "Amiko-Bold",
		family: "Amiko",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Amiko-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Amiko-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			6,
			16,
			54,
			56
		]
	},
	{
		name: "Amiko",
		fontFile: "Amiko-Regular",
		family: "Amiko",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Amiko-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Amiko-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			6,
			16,
			54,
			56
		]
	},
	{
		name: "Andika",
		fontFile: "Andika-Regular",
		family: "Andika",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Andika-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Andika-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			8,
			9,
			49,
			50,
			51,
			52,
			54,
			55,
			56,
			59,
			60,
			103,
			113,
			115,
			120
		]
	},
	{
		name: "Andalus",
		fontFile: "andlso",
		family: "Andalus",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/andlso.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/andlso.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			12,
			54,
			118
		]
	},
	{
		name: "Angsana New",
		fontFile: "angsa",
		family: "Angsana New",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/angsa.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/angsa.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			26
		]
	},
	{
		name: "Anonymous Pro",
		fontFile: "AnonymousPro-Bold",
		family: "Anonymous Pro",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/AnonymousPro-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/AnonymousPro-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			54,
			66
		]
	},
	{
		name: "Anonymous Pro",
		fontFile: "AnonymousPro-Regular",
		family: "Anonymous Pro",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/AnonymousPro-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/AnonymousPro-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			54,
			66
		]
	},
	{
		name: "Antic",
		fontFile: "Antic-Regular",
		family: "Antic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Antic-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Antic-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Antic Didone",
		fontFile: "AnticDidone-Regular",
		family: "Antic Didone",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/AnticDidone-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/AnticDidone-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Anton",
		fontFile: "Anton-Regular",
		family: "Anton",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Anton-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Anton-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Book Antiqua",
		fontFile: "ANTQUAI",
		family: "Book Antiqua",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/ANTQUAI.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/ANTQUAI.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			54,
			66,
			67,
			68
		]
	},
	{
		name: "Arabic Typesetting",
		fontFile: "arabtype",
		family: "Arabic Typesetting",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/arabtype.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/arabtype.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			5,
			12,
			14,
			54,
			112,
			118
		]
	},
	{
		name: "Arapey",
		fontFile: "Arapey-Regular",
		family: "Arapey",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Arapey-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Arapey-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Arbutus Slab",
		fontFile: "ArbutusSlab-Regular",
		family: "Arbutus Slab",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/ArbutusSlab-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/ArbutusSlab-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Architects Daughter",
		fontFile: "ArchitectsDaughter-Regular",
		family: "Architects Daughter",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/ArchitectsDaughter-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/ArchitectsDaughter-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Archivo Black",
		fontFile: "ArchivoBlack-Regular",
		family: "Archivo Black",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/ArchivoBlack-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/ArchivoBlack-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			54
		]
	},
	{
		name: "Arial",
		fontFile: "Arial",
		family: "Arial",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Arial.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Arial.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			11,
			12,
			52,
			54,
			66,
			67,
			68,
			111,
			118
		]
	},
	{
		name: "Arial",
		fontFile: "arialbd",
		family: "Arial",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/arialbd.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/arialbd.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			11,
			12,
			14,
			49,
			50,
			51,
			52,
			53,
			54,
			56,
			66,
			67,
			68,
			111,
			115,
			118
		]
	},
	{
		name: "Arial",
		fontFile: "arialbi",
		family: "Arial",
		weight: "Bold",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/arialbi.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/arialbi.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			11,
			49,
			50,
			51,
			52,
			53,
			54,
			56,
			66,
			67,
			68,
			111,
			115
		]
	},
	{
		name: "Arial",
		fontFile: "ariali",
		family: "Arial",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/ariali.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/ariali.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			11,
			49,
			50,
			51,
			52,
			53,
			54,
			56,
			66,
			67,
			68,
			111,
			115
		]
	},
	{
		name: "Arial Narrow",
		fontFile: "ArialNarrow",
		family: "Arial Narrow",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/ArialNarrow.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/ArialNarrow.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			54,
			66,
			67,
			68
		]
	},
	{
		name: "Arial Narrow",
		fontFile: "ARIALNB",
		family: "Arial Narrow",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/ARIALNB.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/ARIALNB.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			54,
			66,
			67,
			68
		]
	},
	{
		name: "Arima Madurai",
		fontFile: "ArimaMadurai-Bold",
		family: "Arima Madurai",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/ArimaMadurai-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/ArimaMadurai-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			6,
			21,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Arima Madurai",
		fontFile: "ArimaMadurai-Regular",
		family: "Arima Madurai",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/ArimaMadurai-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/ArimaMadurai-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			6,
			21,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Arimo",
		fontFile: "Arimo-Bold",
		family: "Arimo",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Arimo-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Arimo-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			11,
			49,
			50,
			51,
			52,
			53,
			54,
			55,
			56,
			58,
			66,
			67,
			68,
			83,
			103,
			111,
			115
		]
	},
	{
		name: "Arimo",
		fontFile: "Arimo-Regular",
		family: "Arimo",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Arimo-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Arimo-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			11,
			49,
			50,
			51,
			52,
			53,
			54,
			55,
			56,
			58,
			66,
			67,
			68,
			83,
			103,
			111,
			115
		]
	},
	{
		name: "Arista 2.0",
		fontFile: "Arista2.0",
		family: "Arista 2.0",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Arista2.0.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Arista2.0.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Arizonia",
		fontFile: "Arizonia-Regular",
		family: "Arizonia",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Arizonia-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Arizonia-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Arial Rounded MT Bold",
		fontFile: "ARLRDBD",
		family: "Arial Rounded MT Bold",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/ARLRDBD.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/ARLRDBD.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Arno Pro Caption",
		fontFile: "ArnoPro-Caption",
		family: "Arno Pro Caption",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/ArnoPro-Caption.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/ArnoPro-Caption.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			7,
			8,
			52,
			53,
			54,
			55
		]
	},
	{
		name: "Arno Pro",
		fontFile: "ArnoPro-Italic",
		family: "Arno Pro",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/ArnoPro-Italic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/ArnoPro-Italic.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			7,
			8,
			52,
			53,
			54,
			55
		]
	},
	{
		name: "Arno Pro",
		fontFile: "ArnoPro-Regular",
		family: "Arno Pro",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/ArnoPro-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/ArnoPro-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			7,
			8,
			52,
			53,
			54,
			55
		]
	},
	{
		name: "Arvo",
		fontFile: "Arvo-Bold",
		family: "Arvo",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Arvo-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Arvo-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Arvo",
		fontFile: "Arvo-Regular",
		family: "Arvo",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Arvo-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Arvo-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Asap",
		fontFile: "Asap-Regular",
		family: "Asap",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Asap-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Asap-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			6,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Asset",
		fontFile: "Asset-Regular",
		family: "Asset",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Asset-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Asset-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Assistant",
		fontFile: "Assistant-Bold",
		family: "Assistant",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Assistant-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Assistant-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			6,
			11,
			54,
			111
		]
	},
	{
		name: "Assistant",
		fontFile: "Assistant-Light",
		family: "Assistant Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Assistant-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Assistant-Light.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			6,
			11,
			54,
			111
		]
	},
	{
		name: "Assistant",
		fontFile: "Assistant-Regular",
		family: "Assistant",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Assistant-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Assistant-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			6,
			11,
			54,
			111
		]
	},
	{
		name: "Agfa Rotis Sans Serif",
		fontFile: "at646__",
		family: "Agfa Rotis Sans Serif",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/at646__.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/at646__.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Athiti",
		fontFile: "Athiti-Bold",
		family: "Athiti",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Athiti-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Athiti-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			26,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Athiti",
		fontFile: "Athiti-Light",
		family: "Athiti Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Athiti-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Athiti-Light.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			26,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Athiti",
		fontFile: "Athiti-Regular",
		family: "Athiti",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Athiti-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Athiti-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			26,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Atma",
		fontFile: "Atma-Bold",
		family: "Atma",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Atma-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Atma-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			17,
			54
		]
	},
	{
		name: "Atma",
		fontFile: "Atma-Light",
		family: "Atma Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Atma-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Atma-Light.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			17,
			54
		]
	},
	{
		name: "Atma",
		fontFile: "Atma-Regular",
		family: "Atma",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Atma-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Atma-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			17,
			54
		]
	},
	{
		name: "Bad Script",
		fontFile: "BadScript-Regular",
		family: "Bad Script",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/BadScript-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/BadScript-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			8
		]
	},
	{
		name: "Ballantines Script EF",
		fontFile: "BallantinesScrEF-Med",
		family: "BallantinesScrEF-Med",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/BallantinesScrEF-Med.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/BallantinesScrEF-Med.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Bangers",
		fontFile: "Bangers-Regular",
		family: "Bangers",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Bangers-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Bangers-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			6,
			52,
			56
		]
	},
	{
		name: "Barlow",
		fontFile: "Barlow-Regular",
		family: "Barlow",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Barlow-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Barlow-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			6,
			52,
			54
		]
	},
	{
		name: "Barlow Condensed",
		fontFile: "BarlowCondensed-Regular",
		family: "Barlow Condensed",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/BarlowCondensed-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/BarlowCondensed-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			6,
			52,
			54
		]
	},
	{
		name: "Baroque Script",
		fontFile: "BaroqueScript",
		family: "Baroque Script",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/BaroqueScript.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/BaroqueScript.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "BauerBodni BT",
		fontFile: "BauerBodni BT Bold",
		family: "BauerBodni BT",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/BauerBodni BT Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/BauerBodni BT Bold.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Bauer Bodoni EF",
		fontFile: "BauerBodoniEF-Regular",
		family: "BauerBodoniEF-Regular",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/BauerBodoniEF-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/BauerBodoniEF-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "BauerBodoni",
		fontFile: "bbrg____",
		family: "BauerBodoni",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/bbrg____.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/bbrg____.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Bebas Neue",
		fontFile: "BebasNeue-Regular",
		family: "Bebas Neue",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/BebasNeue-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/BebasNeue-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			6,
			54,
			55
		]
	},
	{
		name: "Belgrano",
		fontFile: "Belgrano-Regular",
		family: "Belgrano",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Belgrano-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Belgrano-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Belleza",
		fontFile: "Belleza-Regular",
		family: "Belleza",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Belleza-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Belleza-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Bembo",
		fontFile: "Bembo-Bold",
		family: "Bembo",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Bembo-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Bembo-Bold.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Bembo",
		fontFile: "Bembo-BoldItalic",
		family: "Bembo",
		weight: "Bold",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Bembo-BoldItalic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Bembo-BoldItalic.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			54
		]
	},
	{
		name: "Bembo",
		fontFile: "Bembo-Italic",
		family: "Bembo",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Bembo-Italic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Bembo-Italic.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Bembo",
		fontFile: "Bembo",
		family: "Bembo",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Bembo.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Bembo.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "BenjaminGothicMedium",
		fontFile: "benjagm",
		family: "BenjaminGothicMedium",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/benjagm.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/benjagm.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Bentham",
		fontFile: "Bentham-Regular",
		family: "Bentham",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Bentham-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Bentham-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Berkshire Swash",
		fontFile: "BerkshireSwash-Regular",
		family: "Berkshire Swash",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/BerkshireSwash-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/BerkshireSwash-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Bernhard Schönschrift EF",
		fontFile: "BernhardSchoenEF-Regular",
		family: "BernhardSchoenEF-Regular",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/BernhardSchoenEF-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/BernhardSchoenEF-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Bevan",
		fontFile: "Bevan-Regular",
		family: "Bevan",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Bevan-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Bevan-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			6,
			52,
			54,
			56
		]
	},
	{
		name: "Bigelow Rules",
		fontFile: "BigelowRules-Regular",
		family: "Bigelow Rules",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/BigelowRules-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/BigelowRules-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Bilbo Swash Caps",
		fontFile: "BilboSwashCaps-Regular",
		family: "Bilbo Swash Caps",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/BilboSwashCaps-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/BilboSwashCaps-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Billy Ohio",
		fontFile: "BillyOhio",
		family: "Billy Ohio",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/BillyOhio.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/BillyOhio.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Billy Ohio Dua",
		fontFile: "BillyOhioDua",
		family: "Billy Ohio Dua",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/BillyOhioDua.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/BillyOhioDua.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Bitter",
		fontFile: "Bitter-Bold",
		family: "Bitter",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Bitter-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Bitter-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			8,
			9,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Bitter",
		fontFile: "Bitter-Light",
		family: "Bitter Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Bitter-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Bitter-Light.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			8,
			9,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Bitter",
		fontFile: "Bitter-Regular",
		family: "Bitter",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Bitter-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Bitter-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			8,
			9,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Book Antiqua",
		fontFile: "BkAnt",
		family: "Book Antiqua",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/BkAnt.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/BkAnt.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			54,
			66,
			67,
			68
		]
	},
	{
		name: "Black Ops One",
		fontFile: "BlackOpsOne-Regular",
		family: "Black Ops One",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/BlackOpsOne-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/BlackOpsOne-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "BlairITC TT",
		fontFile: "BlairITC_TT_Bold",
		family: "BlairITC TT",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/BlairITC_TT_Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/BlairITC_TT_Bold.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "BlairITC TT",
		fontFile: "BlairITC_TT_Light",
		family: "BlairITC TT",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/BlairITC_TT_Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/BlairITC_TT_Light.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "BlairMdITC TT",
		fontFile: "BlairMdITC_TT_Medium",
		family: "BlairMdITC TT",
		weight: "Medium",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/BlairMdITC_TT_Medium.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/BlairMdITC_TT_Medium.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Boton Pro",
		fontFile: "BotonBol",
		family: "Boton Pro Bold",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/BotonBol.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/BotonBol.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			55
		]
	},
	{
		name: "Boton Pro",
		fontFile: "BotonBolIta",
		family: "Boton Pro Bold",
		weight: "Bold",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/BotonBolIta.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/BotonBolIta.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			55
		]
	},
	{
		name: "Boton Pro",
		fontFile: "BotonIta",
		family: "Boton Pro Regular",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/BotonIta.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/BotonIta.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			55
		]
	},
	{
		name: "Boton Pro",
		fontFile: "BotonLig",
		family: "Boton Pro Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/BotonLig.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/BotonLig.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			55
		]
	},
	{
		name: "Boton Pro",
		fontFile: "BotonLigIta",
		family: "Boton Pro Light",
		weight: "Light",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/BotonLigIta.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/BotonLigIta.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			55
		]
	},
	{
		name: "Boton Pro",
		fontFile: "BotonMed",
		family: "Boton Pro Medium",
		weight: "Medium",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/BotonMed.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/BotonMed.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			55
		]
	},
	{
		name: "Boton Pro",
		fontFile: "BotonMedIta",
		family: "Boton Pro Medium",
		weight: "Medium",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/BotonMedIta.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/BotonMedIta.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			55
		]
	},
	{
		name: "Boton Pro",
		fontFile: "BotonReg",
		family: "Boton Pro Regular",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/BotonReg.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/BotonReg.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			55
		]
	},
	{
		name: "Bree Serif",
		fontFile: "BreeSerif-Regular",
		family: "Bree Serif",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/BreeSerif-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/BreeSerif-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Brush Script Std",
		fontFile: "BrushScriptStd",
		family: "Brush Script Std",
		weight: "Medium",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/BrushScriptStd.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/BrushScriptStd.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Buenard",
		fontFile: "Buenard-Regular",
		family: "Buenard",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Buenard-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Buenard-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			55
		]
	},
	{
		name: "Bungee",
		fontFile: "Bungee-Regular",
		family: "Bungee",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Bungee-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Bungee-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			5,
			6,
			52,
			54,
			55,
			56,
			68,
			119
		]
	},
	{
		name: "Bungee Outline",
		fontFile: "BungeeOutline-Regular",
		family: "Bungee Outline",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/BungeeOutline-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/BungeeOutline-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			5,
			6,
			52,
			54,
			55,
			56,
			68,
			119
		]
	},
	{
		name: "Bungee Shade",
		fontFile: "BungeeShade-Regular",
		family: "Bungee Shade",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/BungeeShade-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/BungeeShade-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			5,
			6,
			52,
			54,
			55,
			56,
			68,
			119
		]
	},
	{
		name: "Cabin",
		fontFile: "Cabin-Bold",
		family: "Cabin",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Cabin-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Cabin-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Cabin",
		fontFile: "Cabin-Regular",
		family: "Cabin",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Cabin-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Cabin-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Cabin Sketch",
		fontFile: "CabinSketch-Bold",
		family: "Cabin Sketch",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/CabinSketch-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/CabinSketch-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Cabin Sketch",
		fontFile: "CabinSketch-Regular",
		family: "Cabin Sketch",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/CabinSketch-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/CabinSketch-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Caesar Dressing",
		fontFile: "CaesarDressing-Regular",
		family: "Caesar Dressing",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/CaesarDressing-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/CaesarDressing-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Cagliostro",
		fontFile: "Cagliostro-Regular",
		family: "Cagliostro",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Cagliostro-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Cagliostro-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Cairo",
		fontFile: "Cairo-Bold",
		family: "Cairo",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Cairo-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Cairo-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			12,
			55,
			112,
			118
		]
	},
	{
		name: "Cairo",
		fontFile: "Cairo-Light",
		family: "Cairo Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Cairo-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Cairo-Light.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			12,
			55,
			112,
			118
		]
	},
	{
		name: "Cairo",
		fontFile: "Cairo-Regular",
		family: "Cairo",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Cairo-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Cairo-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			12,
			55,
			112,
			118
		]
	},
	{
		name: "Candal",
		fontFile: "Candal-Regular",
		family: "Candal",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Candal-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Candal-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Capriola",
		fontFile: "Capriola-Regular",
		family: "Capriola",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Capriola-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Capriola-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Cardo",
		fontFile: "Cardo-Bold",
		family: "Cardo",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Cardo-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Cardo-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			11,
			37,
			49,
			52,
			53,
			54,
			55,
			58,
			71,
			83,
			87,
			111,
			124,
			129,
			130,
			140
		]
	},
	{
		name: "Cardo",
		fontFile: "Cardo-Italic",
		family: "Cardo",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Cardo-Italic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Cardo-Italic.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			11,
			37,
			52,
			53,
			54,
			55,
			58,
			71,
			83,
			87,
			111
		]
	},
	{
		name: "Cardo",
		fontFile: "Cardo-Regular",
		family: "Cardo",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Cardo-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Cardo-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			11,
			37,
			49,
			51,
			52,
			53,
			54,
			55,
			58,
			68,
			71,
			83,
			87,
			109,
			111,
			124,
			125,
			129,
			130,
			140
		]
	},
	{
		name: "Carter One",
		fontFile: "CarterOne-Regular",
		family: "Carter One",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/CarterOne-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/CarterOne-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Caveat",
		fontFile: "Caveat-Bold",
		family: "Caveat",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Caveat-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Caveat-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			6,
			8,
			9,
			54,
			55,
			56
		]
	},
	{
		name: "Caveat",
		fontFile: "Caveat-Regular",
		family: "Caveat",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Caveat-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Caveat-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			6,
			8,
			9,
			54,
			55,
			56
		]
	},
	{
		name: "Caveat Brush",
		fontFile: "CaveatBrush-Regular",
		family: "Caveat Brush",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/CaveatBrush-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/CaveatBrush-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			55,
			56
		]
	},
	{
		name: "Cedarville Cursive",
		fontFile: "Cedarville-Cursive",
		family: "Cedarville Cursive",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Cedarville-Cursive.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Cedarville-Cursive.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Century Gothic",
		fontFile: "CenturyGothic",
		family: "Century Gothic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/CenturyGothic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/CenturyGothic.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "CG Omega",
		fontFile: "cgor45w",
		family: "CG Omega",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/cgor45w.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/cgor45w.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "CG Omega",
		fontFile: "cgor65w",
		family: "CG Omega",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/cgor65w.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/cgor65w.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Challenger",
		fontFile: "Challenger-Bold",
		family: "Challenger",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Challenger-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Challenger-Bold.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			8
		]
	},
	{
		name: "Challenger",
		fontFile: "Challenger-Regular",
		family: "Challenger",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Challenger-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Challenger-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			8
		]
	},
	{
		name: "Chango",
		fontFile: "Chango-Regular",
		family: "Chango",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Chango-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Chango-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Chathura",
		fontFile: "Chathura-Bold",
		family: "Chathura",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Chathura-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Chathura-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			22
		]
	},
	{
		name: "Chathura",
		fontFile: "Chathura-Light",
		family: "Chathura Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Chathura-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Chathura-Light.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			22
		]
	},
	{
		name: "Chathura",
		fontFile: "Chathura-Regular",
		family: "Chathura",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Chathura-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Chathura-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			22
		]
	},
	{
		name: "Chewy",
		fontFile: "Chewy-Regular",
		family: "Chewy",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Chewy-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Chewy-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Cinzel",
		fontFile: "Cinzel-Black",
		family: "Cinzel Black",
		weight: "Black",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Cinzel-Black.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Cinzel-Black.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Cinzel",
		fontFile: "Cinzel-Bold",
		family: "Cinzel",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Cinzel-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Cinzel-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Cinzel",
		fontFile: "Cinzel-Regular",
		family: "Cinzel",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Cinzel-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Cinzel-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Clarendon",
		fontFile: "ClarendonBT-BoldCondensed",
		family: "Clarendon",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/ClarendonBT-BoldCondensed.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/ClarendonBT-BoldCondensed.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Coiny",
		fontFile: "Coiny-Regular",
		family: "Coiny",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Coiny-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Coiny-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			6,
			21,
			52,
			54
		]
	},
	{
		name: "Coming Soon",
		fontFile: "ComingSoon-Regular",
		family: "Coming Soon",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/ComingSoon-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/ComingSoon-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Contrail One",
		fontFile: "ContrailOne-Regular",
		family: "Contrail One",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/ContrailOne-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/ContrailOne-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Cookie",
		fontFile: "Cookie-Regular",
		family: "Cookie",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Cookie-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Cookie-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Copperplate Gothic Bold",
		fontFile: "Coprgtb",
		family: "Copperplate Gothic Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Coprgtb.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Coprgtb.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Cormorant Garamond",
		fontFile: "CormorantGaramond-Bold",
		family: "Cormorant Garamond",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/CormorantGaramond-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/CormorantGaramond-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			8,
			9,
			52,
			54,
			55,
			56,
			68
		]
	},
	{
		name: "Cormorant Garamond",
		fontFile: "CormorantGaramond-Italic",
		family: "Cormorant Garamond",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/CormorantGaramond-Italic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/CormorantGaramond-Italic.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			6,
			8,
			9,
			52,
			54,
			55,
			56,
			68
		]
	},
	{
		name: "Cormorant Garamond",
		fontFile: "CormorantGaramond-Light",
		family: "Cormorant Garamond Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/CormorantGaramond-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/CormorantGaramond-Light.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			8,
			9,
			52,
			54,
			55,
			56,
			68
		]
	},
	{
		name: "Cormorant Garamond",
		fontFile: "CormorantGaramond-Regular",
		family: "Cormorant Garamond",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/CormorantGaramond-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/CormorantGaramond-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			8,
			9,
			52,
			54,
			55,
			56,
			68
		]
	},
	{
		name: "Cormorant SC",
		fontFile: "CormorantSC-Bold",
		family: "Cormorant SC",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/CormorantSC-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/CormorantSC-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			8,
			9,
			52,
			54,
			55,
			56,
			68
		]
	},
	{
		name: "Cormorant SC",
		fontFile: "CormorantSC-Light",
		family: "Cormorant SC Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/CormorantSC-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/CormorantSC-Light.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			8,
			9,
			52,
			54,
			55,
			56,
			68
		]
	},
	{
		name: "Cormorant SC",
		fontFile: "CormorantSC-Regular",
		family: "Cormorant SC",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/CormorantSC-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/CormorantSC-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			8,
			9,
			52,
			54,
			55,
			56,
			68
		]
	},
	{
		name: "Corona LT Std",
		fontFile: "CoronaLTStd-BoldFaceNo2",
		family: "Corona LT Std",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/CoronaLTStd-BoldFaceNo2.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/CoronaLTStd-BoldFaceNo2.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Corona LT Std",
		fontFile: "CoronaLTStd-Italic",
		family: "Corona LT Std",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/CoronaLTStd-Italic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/CoronaLTStd-Italic.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Corona LT Std",
		fontFile: "CoronaLTStd",
		family: "Corona LT Std",
		weight: "Medium",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/CoronaLTStd.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/CoronaLTStd.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Courgette",
		fontFile: "Courgette-Regular",
		family: "Courgette",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Courgette-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Courgette-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Courier Prime",
		fontFile: "CourierPrime-Bold",
		family: "Courier Prime",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/CourierPrime-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/CourierPrime-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			54
		]
	},
	{
		name: "Courier Prime",
		fontFile: "CourierPrime-Regular",
		family: "Courier Prime",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/CourierPrime-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/CourierPrime-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			54
		]
	},
	{
		name: "Coustard",
		fontFile: "Coustard-Regular",
		family: "Coustard",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Coustard-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Coustard-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Crafty Girls",
		fontFile: "CraftyGirls-Regular",
		family: "Crafty Girls",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/CraftyGirls-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/CraftyGirls-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Crimson Text",
		fontFile: "CrimsonText-Bold",
		family: "Crimson Text",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/CrimsonText-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/CrimsonText-Bold.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			6,
			52,
			54
		]
	},
	{
		name: "Crimson Text",
		fontFile: "CrimsonText-Italic",
		family: "Crimson Text",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/CrimsonText-Italic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/CrimsonText-Italic.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			6,
			54
		]
	},
	{
		name: "Crimson Text",
		fontFile: "CrimsonText-Regular",
		family: "Crimson Text",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/CrimsonText-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/CrimsonText-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			6,
			7,
			8,
			52,
			53,
			54,
			55
		]
	},
	{
		name: "Crimson Text",
		fontFile: "CrimsonText-SemiBold",
		family: "Crimson Text SemiBold",
		weight: "SemiBold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/CrimsonText-SemiBold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/CrimsonText-SemiBold.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			6,
			54
		]
	},
	{
		name: "Croissant One",
		fontFile: "CroissantOne-Regular",
		family: "Croissant One",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/CroissantOne-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/CroissantOne-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			55
		]
	},
	{
		name: "Crushed",
		fontFile: "Crushed-Regular",
		family: "Crushed",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Crushed-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Crushed-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Cuprum",
		fontFile: "Cuprum-Bold",
		family: "Cuprum",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Cuprum-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Cuprum-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			6,
			8,
			52
		]
	},
	{
		name: "Cuprum",
		fontFile: "Cuprum-Regular",
		family: "Cuprum",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Cuprum-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Cuprum-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			6,
			8,
			52
		]
	},
	{
		name: "Cutive",
		fontFile: "Cutive-Regular",
		family: "Cutive",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Cutive-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Cutive-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Damion",
		fontFile: "Damion-Regular",
		family: "Damion",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Damion-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Damion-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Dancing Script",
		fontFile: "DancingScript-Regular",
		family: "Dancing Script",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/DancingScript-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/DancingScript-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Dawning of a New Day",
		fontFile: "DawningofaNewDay",
		family: "Dawning of a New Day",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/DawningofaNewDay.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/DawningofaNewDay.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Dekko",
		fontFile: "Dekko-Regular",
		family: "Dekko",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Dekko-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Dekko-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			16,
			52
		]
	},
	{
		name: "DelaGothicOne-Regular デラゴシック",
		fontFile: "DelaGothicOne-Regular",
		family: "Dela Gothic One",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/DelaGothicOne-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/DelaGothicOne-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			6,
			7,
			8,
			52,
			54,
			55,
			59,
			61,
			87,
			88,
			89,
			100,
			110,
			119
		]
	},
	{
		name: "Denk One",
		fontFile: "DenkOne-Regular",
		family: "Denk One",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/DenkOne-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/DenkOne-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Didact Gothic",
		fontFile: "DidactGothic-Regular",
		family: "Didact Gothic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/DidactGothic-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/DidactGothic-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			52,
			53,
			54,
			56
		]
	},
	{
		name: "DIN Next LT Pro",
		fontFile: "DINNextLTPro-Light",
		family: "DIN Next LT Pro",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/DINNextLTPro-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/DINNextLTPro-Light.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			55
		]
	},
	{
		name: "DIN Next LT Pro",
		fontFile: "DINNextLTPro-Medium",
		family: "DIN Next LT Pro",
		weight: "Medium",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/DINNextLTPro-Medium.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/DINNextLTPro-Medium.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			55
		]
	},
	{
		name: "Diplomata SC",
		fontFile: "DiplomataSC-Regular",
		family: "Diplomata SC",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/DiplomataSC-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/DiplomataSC-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			54
		]
	},
	{
		name: "Dosis",
		fontFile: "Dosis-Bold",
		family: "Dosis",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Dosis-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Dosis-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			52,
			55
		]
	},
	{
		name: "Dosis",
		fontFile: "Dosis-ExtraLight",
		family: "Dosis",
		weight: "ExtraLight",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Dosis-ExtraLight.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Dosis-ExtraLight.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			55
		]
	},
	{
		name: "Dosis",
		fontFile: "Dosis-Light",
		family: "Dosis Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Dosis-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Dosis-Light.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			52,
			55
		]
	},
	{
		name: "Dosis",
		fontFile: "Dosis-Regular",
		family: "Dosis",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Dosis-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Dosis-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			52,
			55
		]
	},
	{
		name: "Droid Serif",
		fontFile: "DroidSerif-Bold",
		family: "Droid Serif",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/DroidSerif-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/DroidSerif-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Droid Serif",
		fontFile: "DroidSerif-Italic",
		family: "Droid Serif",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/DroidSerif-Italic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/DroidSerif-Italic.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Droid Serif",
		fontFile: "DroidSerif-Regular",
		family: "Droid Serif",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/DroidSerif-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/DroidSerif-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Dr Sugiyama",
		fontFile: "DrSugiyama-Regular",
		family: "Dr Sugiyama",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/DrSugiyama-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/DrSugiyama-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Duru Sans",
		fontFile: "DuruSans-Regular",
		family: "Duru Sans",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/DuruSans-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/DuruSans-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Dynalight",
		fontFile: "Dynalight-Regular",
		family: "Dynalight",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Dynalight-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Dynalight-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Economica",
		fontFile: "Economica-Regular",
		family: "Economica",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Economica-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Economica-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Eczar",
		fontFile: "Eczar-Bold",
		family: "Eczar",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Eczar-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Eczar-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			6,
			16,
			54
		]
	},
	{
		name: "Eczar",
		fontFile: "Eczar-Regular",
		family: "Eczar",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Eczar-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Eczar-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			6,
			16,
			54
		]
	},
	{
		name: "Emblema One",
		fontFile: "EmblemaOne-Regular",
		family: "Emblema One",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/EmblemaOne-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/EmblemaOne-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Engagement",
		fontFile: "Engagement-Regular",
		family: "Engagement",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Engagement-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Engagement-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Eras Bold ITC",
		fontFile: "ErasBD",
		family: "Eras Bold ITC",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/ErasBD.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/ErasBD.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Erica One",
		fontFile: "EricaOne-Regular",
		family: "Erica One",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/EricaOne-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/EricaOne-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Esteh",
		fontFile: "Esteh",
		family: "Esteh",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Esteh.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Esteh.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Euphoria Script",
		fontFile: "EuphoriaScript-Regular",
		family: "Euphoria Script",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/EuphoriaScript-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/EuphoriaScript-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "EuropaGroSBOP-Bol",
		fontFile: "EuropaGroSBOP-Bol",
		family: "EuropaGroSBOP-Bol",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/EuropaGroSBOP-Bol.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/EuropaGroSBOP-Bol.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "EuropaGroSBOP-BolIta",
		fontFile: "EuropaGroSBOP-BolIta",
		family: "EuropaGroSBOP-BolIta",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/EuropaGroSBOP-BolIta.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/EuropaGroSBOP-BolIta.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "EuropaGroSBOP-BooIta",
		fontFile: "EuropaGroSBOP-BooIta",
		family: "EuropaGroSBOP-BooIta",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/EuropaGroSBOP-BooIta.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/EuropaGroSBOP-BooIta.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "EuropaGroSBOP-Book",
		fontFile: "EuropaGroSBOP-Book",
		family: "EuropaGroSBOP-Book",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/EuropaGroSBOP-Book.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/EuropaGroSBOP-Book.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "EuropaGroSBOP-DemBol",
		fontFile: "EuropaGroSBOP-DemBol",
		family: "EuropaGroSBOP-DemBol",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/EuropaGroSBOP-DemBol.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/EuropaGroSBOP-DemBol.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "EuropaGroSBOP-DemBolIta",
		fontFile: "EuropaGroSBOP-DemBolIta",
		family: "EuropaGroSBOP-DemBolIta",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/EuropaGroSBOP-DemBolIta.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/EuropaGroSBOP-DemBolIta.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "EuropaGroSBOP-Ita",
		fontFile: "EuropaGroSBOP-Ita",
		family: "EuropaGroSBOP-Ita",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/EuropaGroSBOP-Ita.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/EuropaGroSBOP-Ita.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "EuropaGroSBOP-Lig",
		fontFile: "EuropaGroSBOP-Lig",
		family: "EuropaGroSBOP-Lig",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/EuropaGroSBOP-Lig.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/EuropaGroSBOP-Lig.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "EuropaGroSBOP-LigIta",
		fontFile: "EuropaGroSBOP-LigIta",
		family: "EuropaGroSBOP-LigIta",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/EuropaGroSBOP-LigIta.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/EuropaGroSBOP-LigIta.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "EuropaGroSBOP-Med",
		fontFile: "EuropaGroSBOP-Med",
		family: "EuropaGroSBOP-Med",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/EuropaGroSBOP-Med.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/EuropaGroSBOP-Med.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "EuropaGroSBOP-MedIta",
		fontFile: "EuropaGroSBOP-MedIta",
		family: "EuropaGroSBOP-MedIta",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/EuropaGroSBOP-MedIta.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/EuropaGroSBOP-MedIta.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Europa Grotesk SB",
		fontFile: "EuropaGroSBOP-Reg",
		family: "EuropaGroSBOP-Reg",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/EuropaGroSBOP-Reg.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/EuropaGroSBOP-Reg.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "EuropaGroSBOP-XLig",
		fontFile: "EuropaGroSBOP-XLig",
		family: "EuropaGroSBOP-XLig",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/EuropaGroSBOP-XLig.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/EuropaGroSBOP-XLig.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "EuropaGroSBOP-XLigIta",
		fontFile: "EuropaGroSBOP-XLigIta",
		family: "EuropaGroSBOP-XLigIta",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/EuropaGroSBOP-XLigIta.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/EuropaGroSBOP-XLigIta.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Eurostile",
		fontFile: "Eurosti",
		family: "Eurostile",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Eurosti.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Eurosti.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Eurostile",
		fontFile: "Eurostib",
		family: "Eurostile",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Eurostib.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Eurostib.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Exo",
		fontFile: "Exo-Bold",
		family: "Exo",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Exo-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Exo-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Exo",
		fontFile: "Exo-Light",
		family: "Exo Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Exo-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Exo-Light.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Exo",
		fontFile: "Exo-Regular",
		family: "Exo",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Exo-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Exo-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Farsan",
		fontFile: "Farsan-Regular",
		family: "Farsan",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Farsan-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Farsan-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			5,
			6,
			19,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Fascinate",
		fontFile: "Fascinate-Regular",
		family: "Fascinate",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Fascinate-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Fascinate-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Fascinate Inline",
		fontFile: "FascinateInline-Regular",
		family: "Fascinate Inline",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/FascinateInline-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/FascinateInline-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Federo",
		fontFile: "Federo-Regular",
		family: "Federo",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Federo-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Federo-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Fira Sans",
		fontFile: "FiraSans-Bold",
		family: "Fira Sans",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/FiraSans-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/FiraSans-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			52,
			53,
			54,
			55,
			56,
			59
		]
	},
	{
		name: "Fira Sans",
		fontFile: "FiraSans-ExtraLight",
		family: "Fira Sans ExtraLight",
		weight: "ExtraLight",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/FiraSans-ExtraLight.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/FiraSans-ExtraLight.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			52,
			53,
			54,
			55,
			56,
			59
		]
	},
	{
		name: "Fira Sans",
		fontFile: "FiraSans-Light",
		family: "Fira Sans Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/FiraSans-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/FiraSans-Light.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			52,
			53,
			54,
			55,
			56,
			59
		]
	},
	{
		name: "Fira Sans",
		fontFile: "FiraSans-Regular",
		family: "Fira Sans",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/FiraSans-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/FiraSans-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			52,
			53,
			54,
			55,
			56,
			59
		]
	},
	{
		name: "Fira Sans",
		fontFile: "FiraSans-Thin",
		family: "Fira Sans Thin",
		weight: "Thin",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/FiraSans-Thin.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/FiraSans-Thin.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			52,
			53,
			54,
			55,
			56,
			59
		]
	},
	{
		name: "Flemish Script II",
		fontFile: "FlemishScriptII",
		family: "Flemish Script II",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/FlemishScriptII.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/FlemishScriptII.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "FontAwesome",
		fontFile: "fontawesome-webfont",
		family: "FontAwesome",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/fontawesome-webfont.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/fontawesome-webfont.png",
		isPremium: false,
		unicodeBlockIndexes: [
		]
	},
	{
		name: "Forum",
		fontFile: "Forum-Regular",
		family: "Forum",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Forum-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Forum-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			8,
			54
		]
	},
	{
		name: "Franklin Gothic Book",
		fontFile: "Frabk",
		family: "Franklin Gothic Book",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Frabk.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Frabk.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			54,
			66,
			67,
			68
		]
	},
	{
		name: "Franklin Gothic Demi",
		fontFile: "Fradm",
		family: "Franklin Gothic Demi",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Fradm.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Fradm.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			54,
			66,
			67,
			68
		]
	},
	{
		name: "Francois One",
		fontFile: "FrancoisOne-Regular",
		family: "Francois One",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/FrancoisOne-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/FrancoisOne-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			6,
			52,
			56
		]
	},
	{
		name: "Free 3 of 9",
		fontFile: "FRE3OF9",
		family: "Free 3 of 9",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/FRE3OF9.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/FRE3OF9.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0
		]
	},
	{
		name: "Free 3 of 9 Extended",
		fontFile: "FRE3OF9X",
		family: "Free 3 of 9 Extended",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/FRE3OF9X.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/FRE3OF9X.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0
		]
	},
	{
		name: "Freckle Face",
		fontFile: "FreckleFace-Regular",
		family: "Freckle Face",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/FreckleFace-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/FreckleFace-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Fredericka the Great",
		fontFile: "FrederickatheGreat-Regular",
		family: "Fredericka the Great",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/FrederickatheGreat-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/FrederickatheGreat-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Fredoka One",
		fontFile: "FredokaOne-Regular",
		family: "Fredoka One",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/FredokaOne-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/FredokaOne-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "French Script",
		fontFile: "FrenchScript",
		family: "French Script",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/FrenchScript.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/FrenchScript.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Frutiger",
		fontFile: "Frutiger-BoldCn",
		family: "Frutiger",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Frutiger-BoldCn.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Frutiger-BoldCn.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			54
		]
	},
	{
		name: "Frutiger",
		fontFile: "Frutiger-Cn",
		family: "Frutiger",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Frutiger-Cn.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Frutiger-Cn.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			54
		]
	},
	{
		name: "Frutiger",
		fontFile: "Frutiger-LightCn",
		family: "Frutiger",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Frutiger-LightCn.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Frutiger-LightCn.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			54
		]
	},
	{
		name: "FS Albert",
		fontFile: "FSAlbert-Bold",
		family: "FS Albert",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/FSAlbert-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/FSAlbert-Bold.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "FS Albert Light",
		fontFile: "FSAlbert-Light",
		family: "FS Albert Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/FSAlbert-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/FSAlbert-Light.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Futura Hv BT",
		fontFile: "Futura Heavy BT",
		family: "Futura Hv BT",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Futura Heavy BT.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Futura Heavy BT.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Futura Md BT",
		fontFile: "Futura Med BT",
		family: "Futura Md BT",
		weight: "Medium",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Futura Med BT.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Futura Med BT.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Futura Bk BT",
		fontFile: "futura_book_bt",
		family: "Futura Bk BT",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/futura_book_bt.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/futura_book_bt.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Futura",
		fontFile: "Futura-Book",
		family: "Futura",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Futura-Book.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Futura-Book.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Futura",
		fontFile: "Futura",
		family: "Futura",
		weight: "Medium",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Futura.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Futura.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Futura® EF",
		fontFile: "FuturaEF-Medium",
		family: "FuturaEFCE-Medium",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/FuturaEF-Medium.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/FuturaEF-Medium.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "GaramondNo5EFOP-Bold",
		fontFile: "GaramondNo5EFOP-Bold",
		family: "GaramondNo5EFOP-Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/GaramondNo5EFOP-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/GaramondNo5EFOP-Bold.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "GaramondNo5EFOP-Light",
		fontFile: "GaramondNo5EFOP-Light",
		family: "GaramondNo5EFOP-Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/GaramondNo5EFOP-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/GaramondNo5EFOP-Light.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "GaramondNo5EFOP-LightItalic",
		fontFile: "GaramondNo5EFOP-LightItalic",
		family: "GaramondNo5EFOP-LightItalic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/GaramondNo5EFOP-LightItalic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/GaramondNo5EFOP-LightItalic.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "GaramontAmstEFOP-Ita",
		fontFile: "GaramontAmstEFOP-Ita",
		family: "GaramontAmstEFOP-Ita",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/GaramontAmstEFOP-Ita.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/GaramontAmstEFOP-Ita.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "GaramontAmstEFOP-Med",
		fontFile: "GaramontAmstEFOP-Med",
		family: "GaramontAmstEFOP-Med",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/GaramontAmstEFOP-Med.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/GaramontAmstEFOP-Med.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "GaramontAmstEFOP-MedIta",
		fontFile: "GaramontAmstEFOP-MedIta",
		family: "GaramontAmstEFOP-MedIta",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/GaramontAmstEFOP-MedIta.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/GaramontAmstEFOP-MedIta.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Garamont Amsterdam EF",
		fontFile: "GaramontAmstEFOP-Rom",
		family: "GaramontAmstEFOP-Rom",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/GaramontAmstEFOP-Rom.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/GaramontAmstEFOP-Rom.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Gelato Sans",
		fontFile: "GelatoSans-Bold",
		family: "Gelato Sans",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/GelatoSans-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/GelatoSans-Bold.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Gelato Sans",
		fontFile: "GelatoSans-Light",
		family: "Gelato Sans Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/GelatoSans-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/GelatoSans-Light.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Gelato Sans",
		fontFile: "GelatoSans-Regular",
		family: "Gelato Sans",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/GelatoSans-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/GelatoSans-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Gill Sans MT",
		fontFile: "GILB____",
		family: "Gill Sans MT",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/GILB____.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/GILB____.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Gill Sans MT Condensed",
		fontFile: "GILC____",
		family: "Gill Sans MT Condensed",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/GILC____.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/GILC____.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Gilda Display",
		fontFile: "GildaDisplay-Regular",
		family: "Gilda Display",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/GildaDisplay-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/GildaDisplay-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			55
		]
	},
	{
		name: "Gill Sans MT",
		fontFile: "GILI____",
		family: "Gill Sans MT",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/GILI____.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/GILI____.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Gill Sans",
		fontFile: "GillSans-Light",
		family: "Gill Sans",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/GillSans-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/GillSans-Light.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Gill Sans",
		fontFile: "GillSans-LightItalic",
		family: "Gill Sans",
		weight: "Light",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/GillSans-LightItalic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/GillSans-LightItalic.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			54
		]
	},
	{
		name: "Gill Sans",
		fontFile: "GillSans",
		family: "Gill Sans",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/GillSans.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/GillSans.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Give You Glory",
		fontFile: "GiveYouGlory-Regular",
		family: "Give You Glory",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/GiveYouGlory-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/GiveYouGlory-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Glass Antiqua",
		fontFile: "GlassAntiqua-Regular",
		family: "Glass Antiqua",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/GlassAntiqua-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/GlassAntiqua-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			54
		]
	},
	{
		name: "Glegoo",
		fontFile: "Glegoo-Bold",
		family: "Glegoo",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Glegoo-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Glegoo-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			16,
			54,
			55
		]
	},
	{
		name: "Glegoo",
		fontFile: "Glegoo-Regular",
		family: "Glegoo",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Glegoo-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Glegoo-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			16,
			54,
			55
		]
	},
	{
		name: "Gloria Hallelujah",
		fontFile: "GloriaHallelujah-Regular",
		family: "Gloria Hallelujah",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/GloriaHallelujah-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/GloriaHallelujah-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Gochi Hand",
		fontFile: "GochiHand-Regular",
		family: "Gochi Hand",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/GochiHand-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/GochiHand-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Gotham Book",
		fontFile: "Gotham-Book",
		family: "Gotham Book",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Gotham-Book.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Gotham-Book.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Gotham Light",
		fontFile: "Gotham-Light",
		family: "Gotham Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Gotham-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Gotham-Light.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "GothamBold",
		fontFile: "GothamBold",
		family: "GothamBold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/GothamBold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/GothamBold.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "GothamBook",
		fontFile: "GothamBook-Italic",
		family: "GothamBook",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/GothamBook-Italic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/GothamBook-Italic.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Gotham HTF",
		fontFile: "GothamHTF-Bold",
		family: "Gotham HTF",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/GothamHTF-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/GothamHTF-Bold.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Gotham HTF Book",
		fontFile: "GothamHTF-Book",
		family: "Gotham HTF Book",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/GothamHTF-Book.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/GothamHTF-Book.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Gotham HTF",
		fontFile: "GothamHTF-Medium",
		family: "Gotham HTF",
		weight: "Medium",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/GothamHTF-Medium.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/GothamHTF-Medium.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Gotham Narrow",
		fontFile: "GothamNarrow-Black",
		family: "Gotham Narrow Black",
		weight: "Black",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/GothamNarrow-Black.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/GothamNarrow-Black.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			54
		]
	},
	{
		name: "Gotham Narrow",
		fontFile: "GothamNarrow-Thin",
		family: "Gotham Narrow Thin",
		weight: "Thin",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/GothamNarrow-Thin.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/GothamNarrow-Thin.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			54
		]
	},
	{
		name: "Gotham Narrow",
		fontFile: "GothamNarrow-XLight",
		family: "Gotham Narrow XLight",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/GothamNarrow-XLight.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/GothamNarrow-XLight.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			54
		]
	},
	{
		name: "Century Gothic",
		fontFile: "Gothicb",
		family: "Century Gothic",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Gothicb.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Gothicb.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			54,
			66,
			67,
			68
		]
	},
	{
		name: "Graduate",
		fontFile: "Graduate-Regular",
		family: "Graduate",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Graduate-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Graduate-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Grand Hotel",
		fontFile: "GrandHotel-Regular",
		family: "Grand Hotel",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/GrandHotel-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/GrandHotel-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Great Vibes",
		fontFile: "GreatVibes-Regular",
		family: "Great Vibes",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/GreatVibes-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/GreatVibes-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			54,
			55
		]
	},
	{
		name: "Gruppo",
		fontFile: "Gruppo-Regular",
		family: "Gruppo",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Gruppo-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Gruppo-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "HachiMaruPop-Regular はちまるポップ",
		fontFile: "HachiMaruPop-Regular",
		family: "Hachi Maru Pop",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/HachiMaruPop-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/HachiMaruPop-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			7,
			8,
			54,
			59,
			87,
			88,
			89,
			100,
			114,
			116,
			119
		]
	},
	{
		name: "Hammersmith One",
		fontFile: "HammersmithOne-Regular",
		family: "Hammersmith One",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/HammersmithOne-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/HammersmithOne-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "HannariMincho-Regular はんなり明朝",
		fontFile: "HannariMincho-Regular",
		family: "HannariMincho",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/HannariMincho-Regular.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/HannariMincho-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			4,
			5,
			6,
			7,
			8,
			54,
			59,
			61,
			65,
			66,
			68,
			84,
			85,
			87,
			88,
			89,
			96,
			97,
			100,
			110,
			114,
			116,
			119
		]
	},
	{
		name: "Harenosora はれのそら明朝",
		fontFile: "Harenosora",
		family: "HarenosoraMincho",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Harenosora.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Harenosora.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			7,
			8,
			54,
			59,
			61,
			65,
			66,
			67,
			68,
			84,
			85,
			87,
			88,
			89,
			96,
			97,
			100,
			116,
			119
		]
	},
	{
		name: "Heebo",
		fontFile: "Heebo-Bold",
		family: "Heebo",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Heebo-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Heebo-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			11,
			54,
			55,
			111
		]
	},
	{
		name: "Heebo",
		fontFile: "Heebo-Light",
		family: "Heebo Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Heebo-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Heebo-Light.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			11,
			54,
			55,
			111
		]
	},
	{
		name: "Heebo",
		fontFile: "Heebo-Regular",
		family: "Heebo",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Heebo-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Heebo-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			11,
			54,
			55,
			111
		]
	},
	{
		name: "Helvetica",
		fontFile: "Helvetica-Reg",
		family: "Helvetica",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Helvetica-Reg.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Helvetica-Reg.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Helvetica Neue LT",
		fontFile: "Helvetica-Regular",
		family: "HelveticaNeue LT 55 Roman",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Helvetica-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Helvetica-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Helvetica Neue",
		fontFile: "HelveticaNeue-Bold",
		family: "Helvetica Neue",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/HelveticaNeue-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/HelveticaNeue-Bold.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Helvetica Neue",
		fontFile: "HelveticaNeue-Light",
		family: "Helvetica Neue",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/HelveticaNeue-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/HelveticaNeue-Light.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Helvetica Neue",
		fontFile: "HelveticaNeue-LightItalic",
		family: "Helvetica Neue",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/HelveticaNeue-LightItalic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/HelveticaNeue-LightItalic.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Helvetica Neue LT Std",
		fontFile: "HelveticaNeueLTStd-Bd",
		family: "HelveticaNeueLT Std",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/HelveticaNeueLTStd-Bd.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/HelveticaNeueLTStd-Bd.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Helvetica Neue LT Std",
		fontFile: "HelveticaNeueLTStd-BdIt",
		family: "Helvetica Neue LT Std",
		weight: "Bold",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/HelveticaNeueLTStd-BdIt.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/HelveticaNeueLTStd-BdIt.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Helvetica Neue LT Std",
		fontFile: "HelveticaNeueLTStd-It",
		family: "Helvetica Neue LT Std",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/HelveticaNeueLTStd-It.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/HelveticaNeueLTStd-It.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Helvetica Neue LT Std",
		fontFile: "HelveticaNeueLTStd-Md",
		family: "HelveticaNeueLT Std Med",
		weight: "Medium",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/HelveticaNeueLTStd-Md.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/HelveticaNeueLTStd-Md.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Helvetica Neue LT Std",
		fontFile: "HelveticaNeueLTStd-MdIt",
		family: "HelveticaNeueLT Std Med",
		weight: "Medium",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/HelveticaNeueLTStd-MdIt.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/HelveticaNeueLTStd-MdIt.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Helvetica Neue LT Std Roman",
		fontFile: "HelveticaNeueLTStd-Roman",
		family: "Helvetica Neue LT Std Roman",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/HelveticaNeueLTStd-Roman.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/HelveticaNeueLTStd-Roman.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Hogarth Script EF",
		fontFile: "HogarthScriptEFOP",
		family: "HogarthScriptEFOP",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/HogarthScriptEFOP.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/HogarthScriptEFOP.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Homemade Apple",
		fontFile: "HomemadeApple-Regular",
		family: "Homemade Apple",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/HomemadeApple-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/HomemadeApple-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Italianno",
		fontFile: "Italianno-Regular",
		family: "Italianno",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Italianno-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Italianno-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			55
		]
	},
	{
		name: "Jandys",
		fontFile: "Jandys",
		family: "Jandys",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Jandys.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Jandys.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Jandys dua",
		fontFile: "Jandysdua",
		family: "Jandys dua",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Jandysdua.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Jandysdua.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "JansonText",
		fontFile: "Jansontr",
		family: "JansonText",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Jansontr.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Jansontr.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Josefin Sans",
		fontFile: "JosefinSans-Bold",
		family: "Josefin Sans",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/JosefinSans-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/JosefinSans-Bold.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Josefin Sans",
		fontFile: "JosefinSans-BoldItalic",
		family: "Josefin Sans",
		weight: "Bold",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/JosefinSans-BoldItalic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/JosefinSans-BoldItalic.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Josefin Sans",
		fontFile: "JosefinSans-Italic",
		family: "Josefin Sans",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/JosefinSans-Italic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/JosefinSans-Italic.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Josefin Sans",
		fontFile: "JosefinSans-Light",
		family: "Josefin Sans",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/JosefinSans-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/JosefinSans-Light.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Josefin Sans",
		fontFile: "JosefinSans-LightItalic",
		family: "Josefin Sans",
		weight: "Light",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/JosefinSans-LightItalic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/JosefinSans-LightItalic.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Josefin Sans",
		fontFile: "JosefinSans-Regular",
		family: "Josefin Sans",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/JosefinSans-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/JosefinSans-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			6,
			52,
			56
		]
	},
	{
		name: "Josefin Sans",
		fontFile: "JosefinSans-SemiBold",
		family: "Josefin Sans",
		weight: "SemiBold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/JosefinSans-SemiBold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/JosefinSans-SemiBold.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Josefin Sans",
		fontFile: "JosefinSans-SemiBoldItalic",
		family: "Josefin Sans",
		weight: "SemiBold",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/JosefinSans-SemiBoldItalic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/JosefinSans-SemiBoldItalic.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Josefin Sans",
		fontFile: "JosefinSans-Thin",
		family: "Josefin Sans",
		weight: "Thin",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/JosefinSans-Thin.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/JosefinSans-Thin.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Josefin Sans",
		fontFile: "JosefinSans-ThinItalic",
		family: "Josefin Sans",
		weight: "Thin",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/JosefinSans-ThinItalic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/JosefinSans-ThinItalic.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Josefin Slab",
		fontFile: "JosefinSlab-Bold",
		family: "Josefin Slab",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/JosefinSlab-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/JosefinSlab-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Josefin Slab",
		fontFile: "JosefinSlab-Italic",
		family: "Josefin Slab",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/JosefinSlab-Italic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/JosefinSlab-Italic.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Josefin Slab",
		fontFile: "JosefinSlab-Regular",
		family: "Josefin Slab",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/JosefinSlab-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/JosefinSlab-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Josefin Slab",
		fontFile: "JosefinSlab-Thin",
		family: "Josefin Slab Thin",
		weight: "Thin",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/JosefinSlab-Thin.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/JosefinSlab-Thin.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Joti One",
		fontFile: "JotiOne-Regular",
		family: "Joti One",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/JotiOne-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/JotiOne-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			55
		]
	},
	{
		name: "Julietrose",
		fontFile: "Julietrose",
		family: "Julietrose",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Julietrose.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Julietrose.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Julius Sans One",
		fontFile: "JuliusSansOne-Regular",
		family: "Julius Sans One",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/JuliusSansOne-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/JuliusSansOne-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Jura",
		fontFile: "Jura-Bold",
		family: "Jura",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Jura-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Jura-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			6,
			7,
			8,
			52,
			53,
			54,
			56
		]
	},
	{
		name: "Jura",
		fontFile: "Jura-Regular",
		family: "Jura",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Jura-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Jura-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			6,
			7,
			8,
			52,
			53,
			54,
			56
		]
	},
	{
		name: "Just Another Hand",
		fontFile: "JustAnotherHand-Regular",
		family: "Just Another Hand",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/JustAnotherHand-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/JustAnotherHand-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Kaffeesatz EF",
		fontFile: "KaffeesatzEF-Schwarz",
		family: "KaffeesatzEF-Schwarz",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/KaffeesatzEF-Schwarz.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/KaffeesatzEF-Schwarz.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "KaiseiHarunoUmi-Bold 解星-春の海（太字）",
		fontFile: "KaiseiHarunoUmi-Bold",
		family: "Kaisei HarunoUmi",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/KaiseiHarunoUmi-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/KaiseiHarunoUmi-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			7,
			8,
			54,
			59,
			65,
			66,
			67,
			68,
			87,
			88,
			89,
			96,
			97,
			100,
			114,
			116,
			119
		]
	},
	{
		name: "KaiseiHarunoUmi-Medium 解星-春の海（ミディアム）",
		fontFile: "KaiseiHarunoUmi-Medium",
		family: "Kaisei HarunoUmi Medium",
		weight: "Medium",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/KaiseiHarunoUmi-Medium.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/KaiseiHarunoUmi-Medium.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			7,
			8,
			54,
			59,
			65,
			66,
			67,
			68,
			87,
			88,
			89,
			96,
			97,
			100,
			114,
			116,
			119
		]
	},
	{
		name: "KaiseiHarunoUmi-Regular 解星-春の海（レギュラー）",
		fontFile: "KaiseiHarunoUmi-Regular",
		family: "Kaisei HarunoUmi",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/KaiseiHarunoUmi-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/KaiseiHarunoUmi-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			7,
			8,
			54,
			59,
			65,
			66,
			67,
			68,
			87,
			88,
			89,
			96,
			97,
			100,
			114,
			116,
			119
		]
	},
	{
		name: "Kalam",
		fontFile: "Kalam-Bold",
		family: "Kalam",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Kalam-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Kalam-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			16,
			54
		]
	},
	{
		name: "Kalam",
		fontFile: "Kalam-Regular",
		family: "Kalam",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Kalam-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Kalam-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			16,
			54
		]
	},
	{
		name: "Karma",
		fontFile: "Karma-Bold",
		family: "Karma",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Karma-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Karma-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			16,
			54
		]
	},
	{
		name: "Karma",
		fontFile: "Karma-Regular",
		family: "Karma",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Karma-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Karma-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			16,
			54
		]
	},
	{
		name: "Kaushan Script",
		fontFile: "KaushanScript-Regular",
		family: "Kaushan Script",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/KaushanScript-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/KaushanScript-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Kavoon",
		fontFile: "Kavoon-Regular",
		family: "Kavoon",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Kavoon-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Kavoon-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			52,
			54
		]
	},
	{
		name: "Kite One",
		fontFile: "KiteOne-Regular",
		family: "Kite One",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/KiteOne-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/KiteOne-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			55
		]
	},
	{
		name: "KiwiMaru-Light キウイ丸（ライト）",
		fontFile: "KiwiMaru-Light",
		family: "Kiwi Maru Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/KiwiMaru-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/KiwiMaru-Light.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			7,
			8,
			54,
			59,
			65,
			66,
			67,
			68,
			84,
			85,
			87,
			88,
			89,
			96,
			97,
			100,
			110,
			114,
			116,
			119
		]
	},
	{
		name: "KiwiMaru-Medium キウイ丸（メディアム）",
		fontFile: "KiwiMaru-Medium",
		family: "Kiwi Maru Medium",
		weight: "Medium",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/KiwiMaru-Medium.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/KiwiMaru-Medium.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			7,
			8,
			54,
			59,
			65,
			66,
			67,
			68,
			84,
			85,
			87,
			88,
			89,
			96,
			97,
			100,
			110,
			114,
			116,
			119
		]
	},
	{
		name: "KiwiMaru-Regular キウイ丸（レギュラー）",
		fontFile: "KiwiMaru-Regular",
		family: "Kiwi Maru",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/KiwiMaru-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/KiwiMaru-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			7,
			8,
			54,
			59,
			65,
			66,
			67,
			68,
			84,
			85,
			87,
			88,
			89,
			96,
			97,
			100,
			110,
			114,
			116,
			119
		]
	},
	{
		name: "Klavika Light",
		fontFile: "Klavika-Light",
		family: "Klavika Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Klavika-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Klavika-Light.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Klavika Medium",
		fontFile: "Klavika-Medium",
		family: "Klavika Medium",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Klavika-Medium.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Klavika-Medium.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Klavika Regular",
		fontFile: "Klavika-Regular",
		family: "Klavika Regular",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Klavika-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Klavika-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Kumar One",
		fontFile: "KumarOne-Regular",
		family: "Kumar One",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/KumarOne-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/KumarOne-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			19
		]
	},
	{
		name: "Kumar One Outline",
		fontFile: "KumarOneOutline-Regular",
		family: "Kumar One Outline",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/KumarOneOutline-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/KumarOneOutline-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			19
		]
	},
	{
		name: "Kurale",
		fontFile: "Kurale-Regular",
		family: "Kurale",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Kurale-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Kurale-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			8,
			16,
			54,
			55,
			56
		]
	},
	{
		name: "La Belle Aurore",
		fontFile: "LaBelleAurore",
		family: "La Belle Aurore",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/LaBelleAurore.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/LaBelleAurore.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Laila",
		fontFile: "Laila-Bold",
		family: "Laila",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Laila-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Laila-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			16,
			54
		]
	},
	{
		name: "Laila",
		fontFile: "Laila-Light",
		family: "Laila Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Laila-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Laila-Light.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			16,
			54
		]
	},
	{
		name: "Laila",
		fontFile: "Laila-Regular",
		family: "Laila",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Laila-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Laila-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			16,
			54
		]
	},
	{
		name: "Lalezar",
		fontFile: "Lalezar-Regular",
		family: "Lalezar",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Lalezar-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Lalezar-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			6,
			12,
			52,
			54,
			112,
			118
		]
	},
	{
		name: "Lancelot",
		fontFile: "Lancelot-Regular",
		family: "Lancelot",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Lancelot-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Lancelot-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Largo EF",
		fontFile: "LargoBEF-Light",
		family: "LargoBEF-Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/LargoBEF-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/LargoBEF-Light.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Lato",
		fontFile: "Lato-Bold",
		family: "Lato",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Lato-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Lato-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Lato",
		fontFile: "Lato-Italic",
		family: "Lato",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Lato-Italic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Lato-Italic.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Lato",
		fontFile: "Lato-Light",
		family: "Lato Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Lato-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Lato-Light.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Lato",
		fontFile: "Lato-Regular",
		family: "Lato",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Lato-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Lato-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "League Gothic",
		fontFile: "LeagueGothic-Regular",
		family: "League Gothic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/LeagueGothic-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/LeagueGothic-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			6,
			52
		]
	},
	{
		name: "League Script",
		fontFile: "LeagueScript-Regular",
		family: "League Script",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/LeagueScript-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/LeagueScript-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Ledger",
		fontFile: "Ledger-Regular",
		family: "Ledger",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Ledger-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Ledger-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			8
		]
	},
	{
		name: "LegacySansFIN",
		fontFile: "LegacySansFIN-Book",
		family: "LegacySansFIN",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/LegacySansFIN-Book.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/LegacySansFIN-Book.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Legacy Sans OS ITC TT",
		fontFile: "legsnow_",
		family: "Legacy Sans OS ITC TT",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/legsnow_.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/legsnow_.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Lekton",
		fontFile: "Lekton-Bold",
		family: "Lekton",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Lekton-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Lekton-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Lekton",
		fontFile: "Lekton-Italic",
		family: "Lekton",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Lekton-Italic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Lekton-Italic.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Lekton",
		fontFile: "Lekton-Regular",
		family: "Lekton",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Lekton-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Lekton-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Lemonada",
		fontFile: "Lemonada-Bold",
		family: "Lemonada",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Lemonada-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Lemonada-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			6,
			12,
			52,
			118
		]
	},
	{
		name: "Lemonada",
		fontFile: "Lemonada-Regular",
		family: "Lemonada",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Lemonada-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Lemonada-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			6,
			12,
			52,
			118
		]
	},
	{
		name: "Libre Baskerville",
		fontFile: "LibreBaskerville-Bold",
		family: "Libre Baskerville",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/LibreBaskerville-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/LibreBaskerville-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			55
		]
	},
	{
		name: "Libre Baskerville",
		fontFile: "LibreBaskerville-Italic",
		family: "Libre Baskerville",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/LibreBaskerville-Italic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/LibreBaskerville-Italic.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			55
		]
	},
	{
		name: "Libre Baskerville",
		fontFile: "LibreBaskerville-Regular",
		family: "Libre Baskerville",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/LibreBaskerville-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/LibreBaskerville-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			55
		]
	},
	{
		name: "Libre Franklin",
		fontFile: "LibreFranklin-Bold",
		family: "Libre Franklin",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/LibreFranklin-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/LibreFranklin-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			6,
			52,
			56
		]
	},
	{
		name: "Libre Franklin",
		fontFile: "LibreFranklin-Italic",
		family: "Libre Franklin",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/LibreFranklin-Italic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/LibreFranklin-Italic.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			6,
			52,
			56
		]
	},
	{
		name: "Libre Franklin",
		fontFile: "LibreFranklin-Regular",
		family: "Libre Franklin",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/LibreFranklin-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/LibreFranklin-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			6,
			52,
			56
		]
	},
	{
		name: "Life Savers",
		fontFile: "LifeSavers-Bold",
		family: "Life Savers",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/LifeSavers-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/LifeSavers-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			55
		]
	},
	{
		name: "Life Savers",
		fontFile: "LifeSavers-Regular",
		family: "Life Savers",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/LifeSavers-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/LifeSavers-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			55
		]
	},
	{
		name: "Lilita One",
		fontFile: "LilitaOne-Regular",
		family: "Lilita One",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/LilitaOne-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/LilitaOne-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Limelight",
		fontFile: "Limelight-Regular",
		family: "Limelight",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Limelight-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Limelight-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "LinotypeErgo",
		fontFile: "LinotypeErgo-DemiBoldItalic",
		family: "LinotypeErgo",
		weight: "SemiBold",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/LinotypeErgo-DemiBoldItalic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/LinotypeErgo-DemiBoldItalic.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "LinotypeErgo",
		fontFile: "LinotypeErgo-Regular",
		family: "LinotypeErgo",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/LinotypeErgo-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/LinotypeErgo-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Lobster",
		fontFile: "Lobster-Regular",
		family: "Lobster",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Lobster-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Lobster-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			8,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Lobster Two",
		fontFile: "LobsterTwo-Bold",
		family: "Lobster Two",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/LobsterTwo-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/LobsterTwo-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Lobster Two",
		fontFile: "LobsterTwo-Italic",
		family: "Lobster Two",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/LobsterTwo-Italic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/LobsterTwo-Italic.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Lobster Two",
		fontFile: "LobsterTwo-Regular",
		family: "Lobster Two",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/LobsterTwo-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/LobsterTwo-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Londrina Shadow",
		fontFile: "LondrinaShadow-Regular",
		family: "Londrina Shadow",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/LondrinaShadow-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/LondrinaShadow-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Londrina Sketch",
		fontFile: "LondrinaSketch-Regular",
		family: "Londrina Sketch",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/LondrinaSketch-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/LondrinaSketch-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Londrina Solid",
		fontFile: "LondrinaSolid-Regular",
		family: "Londrina Solid",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/LondrinaSolid-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/LondrinaSolid-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Long Cang",
		fontFile: "LongCang-Regular",
		family: "Long Cang",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/LongCang-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/LongCang-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			87,
			100,
			116,
			119
		]
	},
	{
		name: "Lora",
		fontFile: "Lora-Bold",
		family: "Lora",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Lora-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Lora-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			6,
			8,
			9,
			52,
			54
		]
	},
	{
		name: "Lora",
		fontFile: "Lora-BoldItalic",
		family: "Lora",
		weight: "Bold",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Lora-BoldItalic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Lora-BoldItalic.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			8
		]
	},
	{
		name: "Lora",
		fontFile: "Lora-Italic",
		family: "Lora",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Lora-Italic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Lora-Italic.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			6,
			8,
			9,
			52,
			54
		]
	},
	{
		name: "Lora",
		fontFile: "Lora-Regular",
		family: "Lora",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Lora-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Lora-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			6,
			8,
			9,
			52,
			54
		]
	},
	{
		name: "Love Ya Like A Sister",
		fontFile: "LoveYaLikeASister",
		family: "Love Ya Like A Sister",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/LoveYaLikeASister.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/LoveYaLikeASister.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Frutiger LT 65 Bold",
		fontFile: "lte50329",
		family: "Frutiger LT 65 Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/lte50329.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/lte50329.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Frutiger LT 55 Roman",
		fontFile: "LTe50331",
		family: "Frutiger LT 55 Roman",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/LTe50331.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/LTe50331.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Luckiest Guy",
		fontFile: "LuckiestGuy-Regular",
		family: "Luckiest Guy",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/LuckiestGuy-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/LuckiestGuy-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Lustria",
		fontFile: "Lustria-Regular",
		family: "Lustria",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Lustria-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Lustria-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Maiden Orange",
		fontFile: "MaidenOrange-Regular",
		family: "Maiden Orange",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/MaidenOrange-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/MaidenOrange-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Maitree",
		fontFile: "Maitree-Bold",
		family: "Maitree",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Maitree-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Maitree-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			26,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Maitree",
		fontFile: "Maitree-Regular",
		family: "Maitree",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Maitree-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Maitree-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			26,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Mallanna",
		fontFile: "Mallanna-Regular",
		family: "Mallanna",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Mallanna-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Mallanna-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			22
		]
	},
	{
		name: "Marcellus",
		fontFile: "Marcellus-Regular",
		family: "Marcellus",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Marcellus-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Marcellus-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Marck Script",
		fontFile: "MarckScript-Regular",
		family: "Marck Script",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/MarckScript-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/MarckScript-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			8
		]
	},
	{
		name: "Martel",
		fontFile: "Martel-Bold",
		family: "Martel",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Martel-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Martel-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			16,
			54
		]
	},
	{
		name: "Martel",
		fontFile: "Martel-Regular",
		family: "Martel",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Martel-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Martel-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			16,
			54
		]
	},
	{
		name: "Martel Sans",
		fontFile: "MartelSans-Bold",
		family: "Martel Sans",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/MartelSans-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/MartelSans-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			16,
			54
		]
	},
	{
		name: "Martel Sans",
		fontFile: "MartelSans-Regular",
		family: "Martel Sans",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/MartelSans-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/MartelSans-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			16,
			54
		]
	},
	{
		name: "Meddon",
		fontFile: "Meddon",
		family: "Meddon",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Meddon.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Meddon.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3
		]
	},
	{
		name: "Megrim",
		fontFile: "Megrim-Regular",
		family: "Megrim",
		weight: "Medium",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Megrim-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Megrim-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Memory",
		fontFile: "memory3",
		family: "Memory",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/memory3.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/memory3.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			54,
			66,
			67
		]
	},
	{
		name: "Merriweather",
		fontFile: "Merriweather-Bold",
		family: "Merriweather",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Merriweather-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Merriweather-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			6,
			8,
			9,
			52,
			54,
			56
		]
	},
	{
		name: "Merriweather",
		fontFile: "Merriweather-Regular",
		family: "Merriweather",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Merriweather-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Merriweather-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			6,
			8,
			9,
			52,
			54,
			56
		]
	},
	{
		name: "Merriweather Sans",
		fontFile: "MerriweatherSans-Bold",
		family: "Merriweather Sans",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/MerriweatherSans-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/MerriweatherSans-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			52,
			54,
			55,
			56,
			59
		]
	},
	{
		name: "Merriweather Sans",
		fontFile: "MerriweatherSans-Italic",
		family: "Merriweather Sans",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/MerriweatherSans-Italic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/MerriweatherSans-Italic.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			52,
			54,
			55,
			56,
			59
		]
	},
	{
		name: "Merriweather Sans",
		fontFile: "MerriweatherSans-Regular",
		family: "Merriweather Sans",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/MerriweatherSans-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/MerriweatherSans-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			52,
			54,
			55,
			56,
			59
		]
	},
	{
		name: "Meta-Bold",
		fontFile: "Meta-Bold",
		family: "Meta-Bold",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Meta-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Meta-Bold.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Meta-Normal",
		fontFile: "Meta-Normal",
		family: "Meta-Normal",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Meta-Normal.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Meta-Normal.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "MetaPro-Black",
		fontFile: "MetaPro-Black",
		family: "MetaPro-Black",
		weight: "Black",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/MetaPro-Black.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/MetaPro-Black.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			54,
			55
		]
	},
	{
		name: "MetaPro-Medium",
		fontFile: "MetaPro-Medium",
		family: "MetaPro-Medium",
		weight: "Medium",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/MetaPro-Medium.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/MetaPro-Medium.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			54,
			55
		]
	},
	{
		name: "MetaPro-Normal",
		fontFile: "MetaPro-Normal",
		family: "MetaPro-Normal",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/MetaPro-Normal.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/MetaPro-Normal.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			54,
			55
		]
	},
	{
		name: "Michroma",
		fontFile: "Michroma-Regular",
		family: "Michroma",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Michroma-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Michroma-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3
		]
	},
	{
		name: "Minion Pro",
		fontFile: "MinionPro-It",
		family: "Minion Pro",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/MinionPro-It.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/MinionPro-It.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			53,
			54,
			55
		]
	},
	{
		name: "Mirza",
		fontFile: "Mirza-Bold",
		family: "Mirza",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Mirza-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Mirza-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			6,
			12,
			14,
			54,
			112,
			118
		]
	},
	{
		name: "Mirza",
		fontFile: "Mirza-Regular",
		family: "Mirza",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Mirza-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Mirza-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			6,
			12,
			14,
			54,
			112,
			118
		]
	},
	{
		name: "MochiyPopOne-Regular M＋（ブラック）",
		fontFile: "MochiyPopOne-Regular",
		family: "Mochiy Pop One",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/MochiyPopOne-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/MochiyPopOne-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			54,
			84,
			87,
			88,
			89,
			95,
			100,
			114,
			116,
			119
		]
	},
	{
		name: "Mogra",
		fontFile: "Mogra-Regular",
		family: "Mogra",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Mogra-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Mogra-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			19
		]
	},
	{
		name: "Monda",
		fontFile: "Monda-Bold",
		family: "Monda",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Monda-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Monda-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Monda",
		fontFile: "Monda-Regular",
		family: "Monda",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Monda-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Monda-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Monoton",
		fontFile: "Monoton-Regular",
		family: "Monoton",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Monoton-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Monoton-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "MontessoriScript",
		fontFile: "montessoriscript",
		family: "MontessoriScript",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/montessoriscript.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/montessoriscript.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Montserrat",
		fontFile: "Montserrat-Regular",
		family: "Montserrat",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Montserrat-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Montserrat-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			8,
			9,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "MPLUS1p-Black M＋（ボールド）",
		fontFile: "MPLUS1p-Black",
		family: "M PLUS 1p Black",
		weight: "Black",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/MPLUS1p-Black.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/MPLUS1p-Black.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			11,
			49,
			50,
			52,
			53,
			54,
			55,
			56,
			58,
			59,
			60,
			61,
			63,
			65,
			66,
			67,
			68,
			69,
			70,
			84,
			85,
			87,
			88,
			89,
			95,
			100,
			119
		]
	},
	{
		name: "MPLUS1p-Bold M＋（エキストラボールド）",
		fontFile: "MPLUS1p-Bold",
		family: "M PLUS 1p",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/MPLUS1p-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/MPLUS1p-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			11,
			49,
			50,
			52,
			53,
			54,
			55,
			56,
			58,
			59,
			60,
			61,
			63,
			65,
			66,
			67,
			68,
			69,
			70,
			84,
			85,
			87,
			88,
			89,
			95,
			100,
			119
		]
	},
	{
		name: "MPLUS1p-ExtraBold M＋（ライト）",
		fontFile: "MPLUS1p-ExtraBold",
		family: "M PLUS 1p ExtraBold",
		weight: "ExtraBold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/MPLUS1p-ExtraBold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/MPLUS1p-ExtraBold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			11,
			49,
			50,
			52,
			53,
			54,
			55,
			56,
			58,
			59,
			60,
			61,
			63,
			65,
			66,
			67,
			68,
			69,
			70,
			84,
			85,
			87,
			88,
			89,
			95,
			100,
			119
		]
	},
	{
		name: "MPLUS1p-Light M＋（メディアム）",
		fontFile: "MPLUS1p-Light",
		family: "M PLUS 1p Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/MPLUS1p-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/MPLUS1p-Light.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			11,
			49,
			50,
			52,
			53,
			54,
			55,
			56,
			58,
			59,
			60,
			61,
			63,
			65,
			66,
			67,
			68,
			69,
			70,
			84,
			85,
			87,
			88,
			89,
			95,
			100,
			119
		]
	},
	{
		name: "MPLUS1p-Medium M＋（レギュラー）",
		fontFile: "MPLUS1p-Medium",
		family: "M PLUS 1p Medium",
		weight: "Medium",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/MPLUS1p-Medium.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/MPLUS1p-Medium.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			11,
			49,
			50,
			52,
			53,
			54,
			55,
			56,
			58,
			59,
			60,
			61,
			63,
			65,
			66,
			67,
			68,
			69,
			70,
			84,
			85,
			87,
			88,
			89,
			95,
			100,
			119
		]
	},
	{
		name: "MPLUS1p-Regular M＋（スリム）",
		fontFile: "MPLUS1p-Regular",
		family: "M PLUS 1p",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/MPLUS1p-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/MPLUS1p-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			11,
			49,
			50,
			52,
			53,
			54,
			55,
			56,
			58,
			59,
			60,
			61,
			63,
			65,
			66,
			67,
			68,
			69,
			70,
			84,
			85,
			87,
			88,
			89,
			95,
			100,
			119
		]
	},
	{
		name: "Mr Dafoe",
		fontFile: "MrDafoe-Regular",
		family: "Mr Dafoe",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/MrDafoe-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/MrDafoe-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Muli",
		fontFile: "Muli-Bold",
		family: "Muli",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Muli-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Muli-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Muli",
		fontFile: "Muli-Italic",
		family: "Muli",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Muli-Italic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Muli-Italic.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Muli",
		fontFile: "Muli-Regular",
		family: "Muli",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Muli-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Muli-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Myriad Pro",
		fontFile: "MyriadPro-Bold",
		family: "Myriad Pro",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/MyriadPro-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/MyriadPro-Bold.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			55
		]
	},
	{
		name: "Myriad Pro Condensed",
		fontFile: "MyriadPro-Cond",
		family: "Myriad Pro Condensed",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/MyriadPro-Cond.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/MyriadPro-Cond.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			55
		]
	},
	{
		name: "Myriad Pro Condensed",
		fontFile: "MyriadPro-CondIt",
		family: "Myriad Pro Condensed",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/MyriadPro-CondIt.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/MyriadPro-CondIt.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			55
		]
	},
	{
		name: "Myriad Pro",
		fontFile: "MyriadPro-It",
		family: "Myriad Pro",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/MyriadPro-It.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/MyriadPro-It.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			55
		]
	},
	{
		name: "Myriad Pro",
		fontFile: "MyriadPro-Light",
		family: "Myriad Pro",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/MyriadPro-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/MyriadPro-Light.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			55
		]
	},
	{
		name: "Myriad Pro",
		fontFile: "MyriadPro-Regular",
		family: "Myriad Pro",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/MyriadPro-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/MyriadPro-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			55
		]
	},
	{
		name: "Myriad Pro Condensed",
		fontFile: "MyriadPro-SemiboldCond",
		family: "Myriad Pro Condensed",
		weight: "SemiBold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/MyriadPro-SemiboldCond.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/MyriadPro-SemiboldCond.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			55
		]
	},
	{
		name: "NanumGothic",
		fontFile: "NanumGothic-Regular",
		family: "NanumGothic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NanumGothic-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NanumGothic-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			7,
			8,
			31,
			54,
			55,
			59,
			60,
			61,
			65,
			66,
			68,
			85,
			87,
			88,
			89,
			91,
			96,
			97,
			100,
			105,
			119
		]
	},
	{
		name: "News Cycle",
		fontFile: "NewsCycle-Bold",
		family: "News Cycle",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NewsCycle-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NewsCycle-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			52,
			54
		]
	},
	{
		name: "News Cycle",
		fontFile: "NewsCycle-Regular",
		family: "News Cycle",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NewsCycle-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NewsCycle-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			7,
			8,
			52,
			53,
			54,
			55,
			61
		]
	},
	{
		name: "Niconne",
		fontFile: "Niconne-Regular",
		family: "Niconne",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Niconne-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Niconne-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Nixie One",
		fontFile: "NixieOne-Regular",
		family: "Nixie One",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NixieOne-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NixieOne-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Notable",
		fontFile: "Notable-Regular",
		family: "Notable",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Notable-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Notable-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Noticia Text",
		fontFile: "NoticiaText-Bold",
		family: "Noticia Text",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NoticiaText-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NoticiaText-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Noticia Text",
		fontFile: "NoticiaText-Italic",
		family: "Noticia Text",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NoticiaText-Italic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NoticiaText-Italic.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Noticia Text",
		fontFile: "NoticiaText-Regular",
		family: "Noticia Text",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NoticiaText-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NoticiaText-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Noto Emoji",
		fontFile: "NotoEmoji-Bold",
		family: "Noto Emoji",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoEmoji-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoEmoji-Bold.png",
		isPremium: false,
		unicodeBlockIndexes: [
			69,
			70,
			146,
			148,
			149,
			150,
			154,
			158
		]
	},
	{
		name: "Noto Emoji",
		fontFile: "NotoEmoji-Light",
		family: "Noto Emoji Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoEmoji-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoEmoji-Light.png",
		isPremium: false,
		unicodeBlockIndexes: [
			69,
			70,
			146,
			148,
			149,
			150,
			154,
			158
		]
	},
	{
		name: "Noto Emoji",
		fontFile: "NotoEmoji-Medium",
		family: "Noto Emoji Medium",
		weight: "Medium",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoEmoji-Medium.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoEmoji-Medium.png",
		isPremium: false,
		unicodeBlockIndexes: [
			69,
			70,
			146,
			148,
			149,
			150,
			154,
			158
		]
	},
	{
		name: "Noto Emoji",
		fontFile: "NotoEmoji-Regular",
		family: "Noto Emoji",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoEmoji-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoEmoji-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			69,
			70,
			146,
			148,
			149,
			150,
			154,
			158
		]
	},
	{
		name: "Noto Emoji",
		fontFile: "NotoEmoji-SemiBold",
		family: "Noto Emoji SemiBold",
		weight: "SemiBold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoEmoji-SemiBold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoEmoji-SemiBold.png",
		isPremium: false,
		unicodeBlockIndexes: [
			69,
			70,
			146,
			148,
			149,
			150,
			154,
			158
		]
	},
	{
		name: "Noto Sans",
		fontFile: "NotoSans-Bold",
		family: "Noto Sans",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSans-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSans-Bold.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			16,
			49,
			50,
			51,
			52,
			53,
			54,
			55,
			56,
			66,
			67,
			68,
			103,
			115
		]
	},
	{
		name: "Noto Sans",
		fontFile: "NotoSans-Italic",
		family: "Noto Sans",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSans-Italic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSans-Italic.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			49,
			50,
			51,
			52,
			53,
			54,
			55,
			56,
			66,
			67,
			68,
			103,
			115
		]
	},
	{
		name: "Noto Sans",
		fontFile: "NotoSans-Regular",
		family: "Noto Sans",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSans-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSans-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			16,
			49,
			50,
			51,
			52,
			53,
			54,
			55,
			56,
			66,
			67,
			68,
			103,
			115
		]
	},
	{
		name: "Noto Sans Display",
		fontFile: "NotoSansDisplay-Bold",
		family: "Noto Sans Display",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSansDisplay-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSansDisplay-Bold.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			49,
			50,
			51,
			52,
			53,
			54,
			55,
			56,
			58,
			59,
			83,
			103,
			115
		]
	},
	{
		name: "Noto Sans Display",
		fontFile: "NotoSansDisplay-Italic",
		family: "Noto Sans Display",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSansDisplay-Italic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSansDisplay-Italic.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			49,
			50,
			51,
			52,
			53,
			54,
			55,
			56,
			58,
			59,
			83,
			103,
			115
		]
	},
	{
		name: "Noto Sans Display",
		fontFile: "NotoSansDisplay-Light",
		family: "Noto Sans Display Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSansDisplay-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSansDisplay-Light.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			49,
			50,
			51,
			52,
			53,
			54,
			55,
			56,
			58,
			59,
			83,
			103,
			115
		]
	},
	{
		name: "Noto Sans Display",
		fontFile: "NotoSansDisplay-Regular",
		family: "Noto Sans Display",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSansDisplay-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSansDisplay-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			49,
			50,
			51,
			52,
			53,
			54,
			55,
			56,
			58,
			59,
			83,
			103,
			115
		]
	},
	{
		name: "Noto Sans HK",
		fontFile: "NotoSansHK-Bold",
		family: "Noto Sans HK",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSansHK-Bold.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSansHK-Bold.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "Noto Sans HK",
		fontFile: "NotoSansHK-Light",
		family: "Noto Sans HK Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSansHK-Light.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSansHK-Light.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "Noto Sans HK",
		fontFile: "NotoSansHK-Regular",
		family: "Noto Sans HK",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSansHK-Regular.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSansHK-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "Noto Sans JP",
		fontFile: "NotoSansJP-Bold",
		family: "Noto Sans JP",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSansJP-Bold.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSansJP-Bold.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			110,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "Noto Sans JP",
		fontFile: "NotoSansJP-Light",
		family: "Noto Sans JP Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSansJP-Light.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSansJP-Light.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			110,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "Noto Sans JP",
		fontFile: "NotoSansJP-Regular",
		family: "Noto Sans JP",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSansJP-Regular.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSansJP-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			110,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "Noto Sans KR",
		fontFile: "NotoSansKR-Bold",
		family: "Noto Sans KR",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSansKR-Bold.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSansKR-Bold.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			31,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			105,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "Noto Sans KR",
		fontFile: "NotoSansKR-Light",
		family: "Noto Sans KR Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSansKR-Light.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSansKR-Light.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			31,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			105,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "Noto Sans KR",
		fontFile: "NotoSansKR-Regular",
		family: "Noto Sans KR",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSansKR-Regular.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSansKR-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			31,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			105,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "Noto Sans Mono",
		fontFile: "NotoSansMono-Bold",
		family: "Noto Sans Mono",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSansMono-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSansMono-Bold.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			49,
			50,
			51,
			52,
			53,
			54,
			55,
			56,
			58,
			59,
			60,
			61,
			62,
			66,
			67,
			68,
			71,
			83,
			103,
			115
		]
	},
	{
		name: "Noto Sans Mono",
		fontFile: "NotoSansMono-Light",
		family: "Noto Sans Mono Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSansMono-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSansMono-Light.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			49,
			50,
			51,
			52,
			53,
			54,
			55,
			56,
			58,
			59,
			60,
			61,
			62,
			66,
			67,
			68,
			71,
			83,
			103,
			115
		]
	},
	{
		name: "Noto Sans Mono",
		fontFile: "NotoSansMono-Regular",
		family: "Noto Sans Mono",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSansMono-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSansMono-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			49,
			50,
			51,
			52,
			53,
			54,
			55,
			56,
			58,
			59,
			60,
			61,
			62,
			66,
			67,
			68,
			71,
			83,
			103,
			115
		]
	},
	{
		name: "Noto Sans SC",
		fontFile: "NotoSansSC-Bold",
		family: "Noto Sans SC",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSansSC-Bold.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSansSC-Bold.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			98,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "Noto Sans SC",
		fontFile: "NotoSansSC-Light",
		family: "Noto Sans SC Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSansSC-Light.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSansSC-Light.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			98,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "Noto Sans SC",
		fontFile: "NotoSansSC-Regular",
		family: "Noto Sans SC",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSansSC-Regular.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSansSC-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			98,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "Noto Sans TC",
		fontFile: "NotoSansTC-Bold",
		family: "Noto Sans TC",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSansTC-Bold.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSansTC-Bold.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "Noto Sans TC",
		fontFile: "NotoSansTC-Light",
		family: "Noto Sans TC Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSansTC-Light.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSansTC-Light.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "Noto Sans TC",
		fontFile: "NotoSansTC-Regular",
		family: "Noto Sans TC",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSansTC-Regular.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSansTC-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "Noto Serif",
		fontFile: "NotoSerif-Bold",
		family: "Noto Serif",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSerif-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSerif-Bold.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			49,
			50,
			51,
			52,
			53,
			54,
			55,
			56,
			66,
			67,
			68,
			103,
			115
		]
	},
	{
		name: "Noto Serif",
		fontFile: "NotoSerif-BoldItalic",
		family: "Noto Serif",
		weight: "Bold",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSerif-BoldItalic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSerif-BoldItalic.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			49,
			50,
			51,
			52,
			53,
			54,
			55,
			56,
			66,
			67,
			68,
			103,
			115
		]
	},
	{
		name: "Noto Serif",
		fontFile: "NotoSerif-Italic",
		family: "Noto Serif",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSerif-Italic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSerif-Italic.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			49,
			50,
			51,
			52,
			53,
			54,
			55,
			56,
			66,
			67,
			68,
			103,
			115
		]
	},
	{
		name: "Noto Serif",
		fontFile: "NotoSerif-Regular",
		family: "Noto Serif",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSerif-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSerif-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			49,
			50,
			51,
			52,
			53,
			54,
			55,
			56,
			66,
			67,
			68,
			103,
			115
		]
	},
	{
		name: "Noto Serif Display",
		fontFile: "NotoSerifDisplay-Bold",
		family: "Noto Serif Display",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSerifDisplay-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSerifDisplay-Bold.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			49,
			50,
			51,
			52,
			53,
			54,
			55,
			56,
			58,
			59,
			83,
			103,
			115
		]
	},
	{
		name: "Noto Serif Display",
		fontFile: "NotoSerifDisplay-Italic",
		family: "Noto Serif Display",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSerifDisplay-Italic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSerifDisplay-Italic.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			49,
			50,
			51,
			52,
			53,
			54,
			55,
			56,
			58,
			59,
			83,
			103,
			115
		]
	},
	{
		name: "Noto Serif Display",
		fontFile: "NotoSerifDisplay-Light",
		family: "Noto Serif Display Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSerifDisplay-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSerifDisplay-Light.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			49,
			50,
			51,
			52,
			53,
			54,
			55,
			56,
			58,
			59,
			83,
			103,
			115
		]
	},
	{
		name: "Noto Serif Display",
		fontFile: "NotoSerifDisplay-Regular",
		family: "Noto Serif Display",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSerifDisplay-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSerifDisplay-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			49,
			50,
			51,
			52,
			53,
			54,
			55,
			56,
			58,
			59,
			83,
			103,
			115
		]
	},
	{
		name: "Noto Serif Display",
		fontFile: "NotoSerifDisplay-Thin",
		family: "Noto Serif Display Thin",
		weight: "Thin",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSerifDisplay-Thin.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSerifDisplay-Thin.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			49,
			50,
			51,
			52,
			53,
			54,
			55,
			56,
			58,
			59,
			83,
			103,
			115
		]
	},
	{
		name: "Noto Serif JP",
		fontFile: "NotoSerifJP-Bold",
		family: "Noto Serif JP",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSerifJP-Bold.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSerifJP-Bold.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			110,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "Noto Serif JP",
		fontFile: "NotoSerifJP-Light",
		family: "Noto Serif JP Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSerifJP-Light.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSerifJP-Light.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			110,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "Noto Serif JP",
		fontFile: "NotoSerifJP-Regular",
		family: "Noto Serif JP",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSerifJP-Regular.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSerifJP-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			110,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "Noto Serif KR",
		fontFile: "NotoSerifKR-Bold",
		family: "Noto Serif KR",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSerifKR-Bold.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSerifKR-Bold.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			31,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			105,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "Noto Serif KR",
		fontFile: "NotoSerifKR-Light",
		family: "Noto Serif KR Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSerifKR-Light.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSerifKR-Light.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			31,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			105,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "Noto Serif KR",
		fontFile: "NotoSerifKR-Regular",
		family: "Noto Serif KR",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSerifKR-Regular.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSerifKR-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			31,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			105,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "Noto Serif SC",
		fontFile: "NotoSerifSC-Bold",
		family: "Noto Serif SC",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSerifSC-Bold.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSerifSC-Bold.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			98,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "Noto Serif SC",
		fontFile: "NotoSerifSC-Light",
		family: "Noto Serif SC Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSerifSC-Light.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSerifSC-Light.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			98,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "Noto Serif SC",
		fontFile: "NotoSerifSC-Regular",
		family: "Noto Serif SC",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSerifSC-Regular.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSerifSC-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			98,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "Noto Serif TC",
		fontFile: "NotoSerifTC-Bold",
		family: "Noto Serif TC",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSerifTC-Bold.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSerifTC-Bold.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "Noto Serif TC",
		fontFile: "NotoSerifTC-Light",
		family: "Noto Serif TC Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSerifTC-Light.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSerifTC-Light.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "Noto Serif TC",
		fontFile: "NotoSerifTC-Regular",
		family: "Noto Serif TC",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/NotoSerifTC-Regular.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/NotoSerifTC-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "Nunito",
		fontFile: "Nunito-Bold",
		family: "Nunito",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Nunito-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Nunito-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			8,
			9,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Nunito",
		fontFile: "Nunito-Light",
		family: "Nunito Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Nunito-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Nunito-Light.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			8,
			9,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Nunito",
		fontFile: "Nunito-Regular",
		family: "Nunito",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Nunito-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Nunito-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			8,
			9,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Objektiv Mk2",
		fontFile: "ObjektivMk2_Bd",
		family: "Objektiv Mk2",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/ObjektivMk2_Bd.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/ObjektivMk2_Bd.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			54,
			55,
			59
		]
	},
	{
		name: "Oleo Script",
		fontFile: "OleoScript-Bold",
		family: "Oleo Script",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/OleoScript-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/OleoScript-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Oleo Script",
		fontFile: "OleoScript-Regular",
		family: "Oleo Script",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/OleoScript-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/OleoScript-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Open Sans",
		fontFile: "OpenSans-Bold",
		family: "Open Sans",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/OpenSans-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/OpenSans-Bold.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			9,
			52,
			54,
			55
		]
	},
	{
		name: "Open Sans",
		fontFile: "OpenSans-Regular",
		family: "Open Sans",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/OpenSans-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/OpenSans-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			9,
			52,
			54,
			55
		]
	},
	{
		name: "Optiscript EF",
		fontFile: "OptiscriptEF-Reg",
		family: "OptiscriptEF-Regular",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/OptiscriptEF-Reg.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/OptiscriptEF-Reg.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			54
		]
	},
	{
		name: "Oranienbaum",
		fontFile: "Oranienbaum-Regular",
		family: "Oranienbaum",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Oranienbaum-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Oranienbaum-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			8
		]
	},
	{
		name: "Oregano",
		fontFile: "Oregano-Regular",
		family: "Oregano",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Oregano-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Oregano-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Oswald",
		fontFile: "Oswald-Bold",
		family: "Oswald",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Oswald-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Oswald-Bold.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			6,
			8,
			52,
			54,
			56
		]
	},
	{
		name: "Oswald",
		fontFile: "Oswald-Regular",
		family: "Oswald",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Oswald-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Oswald-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			6,
			8,
			52,
			54,
			56
		]
	},
	{
		name: "Otella Alt",
		fontFile: "OtellaAlt",
		family: "Otella Alt",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/OtellaAlt.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/OtellaAlt.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			54
		]
	},
	{
		name: "Otella",
		fontFile: "OtellaRegular",
		family: "Otella",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/OtellaRegular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/OtellaRegular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Ovo",
		fontFile: "Ovo-Regular",
		family: "Ovo",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Ovo-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Ovo-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Pacifico",
		fontFile: "Pacifico-Regular",
		family: "Pacifico",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Pacifico-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Pacifico-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			6,
			8,
			52,
			56
		]
	},
	{
		name: "Palatino LT Std",
		fontFile: "PALATINOLTSTD-BOLD",
		family: "Palatino LT Std",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/PALATINOLTSTD-BOLD.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/PALATINOLTSTD-BOLD.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Palatino LT Std",
		fontFile: "PALATINOLTSTD-ROMAN",
		family: "Palatino LT Std",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/PALATINOLTSTD-ROMAN.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/PALATINOLTSTD-ROMAN.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Parisienne",
		fontFile: "Parisienne-Regular",
		family: "Parisienne",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Parisienne-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Parisienne-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Passion One",
		fontFile: "PassionOne-Bold",
		family: "Passion One",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/PassionOne-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/PassionOne-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Passion One",
		fontFile: "PassionOne-Regular",
		family: "Passion One",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/PassionOne-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/PassionOne-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Pathway Gothic One",
		fontFile: "PathwayGothicOne-Regular",
		family: "Pathway Gothic One",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/PathwayGothicOne-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/PathwayGothicOne-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			55
		]
	},
	{
		name: "Paytone One",
		fontFile: "PaytoneOne-Regular",
		family: "Paytone One",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/PaytoneOne-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/PaytoneOne-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			6,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Permanent Marker",
		fontFile: "PermanentMarker-Regular",
		family: "Permanent Marker",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/PermanentMarker-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/PermanentMarker-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Pinyon Script",
		fontFile: "PinyonScript-Regular",
		family: "Pinyon Script",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/PinyonScript-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/PinyonScript-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Playfair Display",
		fontFile: "PlayfairDisplay-Black",
		family: "Playfair Display Black",
		weight: "Black",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/PlayfairDisplay-Black.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/PlayfairDisplay-Black.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			6,
			8,
			52,
			54
		]
	},
	{
		name: "Playfair Display",
		fontFile: "PlayfairDisplay-BlackItalic",
		family: "Playfair Display Black",
		weight: "Black",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/PlayfairDisplay-BlackItalic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/PlayfairDisplay-BlackItalic.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			8,
			54
		]
	},
	{
		name: "Playfair Display",
		fontFile: "PlayfairDisplay-Bold",
		family: "Playfair Display",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/PlayfairDisplay-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/PlayfairDisplay-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			6,
			8,
			52,
			54
		]
	},
	{
		name: "Playfair Display",
		fontFile: "PlayfairDisplay-BoldItalic",
		family: "Playfair Display",
		weight: "Bold",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/PlayfairDisplay-BoldItalic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/PlayfairDisplay-BoldItalic.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			8,
			54
		]
	},
	{
		name: "Playfair Display",
		fontFile: "PlayfairDisplay-Italic",
		family: "Playfair Display",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/PlayfairDisplay-Italic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/PlayfairDisplay-Italic.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			8,
			54
		]
	},
	{
		name: "Playfair Display",
		fontFile: "PlayfairDisplay-Regular",
		family: "Playfair Display",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/PlayfairDisplay-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/PlayfairDisplay-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			6,
			8,
			52,
			54
		]
	},
	{
		name: "Playfair Display SC",
		fontFile: "PlayfairDisplaySC-Regular",
		family: "Playfair Display SC",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/PlayfairDisplaySC-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/PlayfairDisplaySC-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			8,
			54
		]
	},
	{
		name: "Podkova",
		fontFile: "Podkova-Bold",
		family: "Podkova",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Podkova-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Podkova-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			8,
			9,
			52,
			54,
			56
		]
	},
	{
		name: "Podkova",
		fontFile: "Podkova-Regular",
		family: "Podkova",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Podkova-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Podkova-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			8,
			9,
			52,
			54,
			56
		]
	},
	{
		name: "Poiret One",
		fontFile: "PoiretOne-Regular",
		family: "Poiret One",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/PoiretOne-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/PoiretOne-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			8
		]
	},
	{
		name: "Pompiere ",
		fontFile: "Pompiere-Regular",
		family: "Pompiere ",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Pompiere-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Pompiere-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Prata",
		fontFile: "Prata-Regular",
		family: "Prata",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Prata-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Prata-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			8,
			52
		]
	},
	{
		name: "PT Sans",
		fontFile: "PTSans-Bold",
		family: "PT Sans",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/PTSans-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/PTSans-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			8,
			9,
			54,
			56
		]
	},
	{
		name: "PT Sans",
		fontFile: "PTSans-Italic",
		family: "PT Sans",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/PTSans-Italic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/PTSans-Italic.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			8,
			9,
			54,
			56
		]
	},
	{
		name: "PT Sans",
		fontFile: "PTSans-Regular",
		family: "PT Sans",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/PTSans-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/PTSans-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			8,
			9,
			54,
			56
		]
	},
	{
		name: "PT Serif",
		fontFile: "PTSerif-Bold",
		family: "PT Serif",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/PTSerif-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/PTSerif-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			8,
			9,
			54,
			56
		]
	},
	{
		name: "PT Serif",
		fontFile: "PTSerif-Italic",
		family: "PT Serif",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/PTSerif-Italic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/PTSerif-Italic.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			8,
			9,
			54,
			56
		]
	},
	{
		name: "PT Serif",
		fontFile: "PTSerif-Regular",
		family: "PT Serif",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/PTSerif-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/PTSerif-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			8,
			9,
			54,
			56
		]
	},
	{
		name: "Quando",
		fontFile: "Quando-Regular",
		family: "Quando",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Quando-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Quando-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Quattrocento",
		fontFile: "Quattrocento-Bold",
		family: "Quattrocento",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Quattrocento-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Quattrocento-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Quattrocento",
		fontFile: "Quattrocento-Regular",
		family: "Quattrocento",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Quattrocento-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Quattrocento-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Questrial",
		fontFile: "Questrial-Regular",
		family: "Questrial",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Questrial-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Questrial-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Quicksand",
		fontFile: "Quicksand-Bold",
		family: "Quicksand",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Quicksand-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Quicksand-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Quicksand",
		fontFile: "Quicksand-Light",
		family: "Quicksand Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Quicksand-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Quicksand-Light.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Quicksand",
		fontFile: "Quicksand-Regular",
		family: "Quicksand",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Quicksand-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Quicksand-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Quintessential",
		fontFile: "Quintessential-Regular",
		family: "Quintessential",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Quintessential-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Quintessential-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Racing Sans One",
		fontFile: "RacingSansOne-Regular",
		family: "Racing Sans One",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/RacingSansOne-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/RacingSansOne-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			55
		]
	},
	{
		name: "Radley",
		fontFile: "Radley-Italic",
		family: "Radley",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Radley-Italic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Radley-Italic.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3
		]
	},
	{
		name: "Radley",
		fontFile: "Radley-Regular",
		family: "Radley",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Radley-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Radley-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3
		]
	},
	{
		name: "Rajdhani",
		fontFile: "Rajdhani-Bold",
		family: "Rajdhani",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Rajdhani-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Rajdhani-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			16,
			54
		]
	},
	{
		name: "Rajdhani",
		fontFile: "Rajdhani-Light",
		family: "Rajdhani Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Rajdhani-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Rajdhani-Light.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			16,
			54
		]
	},
	{
		name: "Rajdhani",
		fontFile: "Rajdhani-Regular",
		family: "Rajdhani",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Rajdhani-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Rajdhani-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			16,
			54
		]
	},
	{
		name: "Rakkas",
		fontFile: "Rakkas-Regular",
		family: "Rakkas",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Rakkas-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Rakkas-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			6,
			12,
			118
		]
	},
	{
		name: "Raleway",
		fontFile: "Raleway-Bold",
		family: "Raleway",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Raleway-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Raleway-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			8,
			9,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Raleway",
		fontFile: "Raleway-Italic",
		family: "Raleway",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Raleway-Italic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Raleway-Italic.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			8,
			9,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Raleway",
		fontFile: "Raleway-Light",
		family: "Raleway Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Raleway-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Raleway-Light.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			8,
			9,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Raleway",
		fontFile: "Raleway-Regular",
		family: "Raleway",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Raleway-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Raleway-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			8,
			9,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Raleway Dots",
		fontFile: "RalewayDots-Regular",
		family: "Raleway Dots",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/RalewayDots-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/RalewayDots-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			55
		]
	},
	{
		name: "Ramabhadra",
		fontFile: "Ramabhadra-Regular",
		family: "Ramabhadra",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Ramabhadra-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Ramabhadra-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			22
		]
	},
	{
		name: "Rasa",
		fontFile: "Rasa-Bold",
		family: "Rasa",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Rasa-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Rasa-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			19,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Rasa",
		fontFile: "Rasa-Italic",
		family: "Rasa",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Rasa-Italic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Rasa-Italic.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Rasa",
		fontFile: "Rasa-Light",
		family: "Rasa Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Rasa-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Rasa-Light.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			19,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Rasa",
		fontFile: "Rasa-Regular",
		family: "Rasa",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Rasa-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Rasa-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			19,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Redressed",
		fontFile: "Redressed-Regular",
		family: "Redressed",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Redressed-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Redressed-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Reenie Beanie",
		fontFile: "ReenieBeanie",
		family: "Reenie Beanie",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/ReenieBeanie.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/ReenieBeanie.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Ribeye",
		fontFile: "Ribeye-Regular",
		family: "Ribeye",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Ribeye-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Ribeye-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Ribeye Marrow",
		fontFile: "RibeyeMarrow-Regular",
		family: "Ribeye Marrow",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/RibeyeMarrow-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/RibeyeMarrow-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Roboto",
		fontFile: "Roboto-Bold",
		family: "Roboto",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Roboto-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Roboto-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			9,
			52,
			54,
			56
		]
	},
	{
		name: "Roboto",
		fontFile: "Roboto-Italic",
		family: "Roboto",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Roboto-Italic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Roboto-Italic.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			9,
			52,
			54,
			56
		]
	},
	{
		name: "Roboto",
		fontFile: "Roboto-Light",
		family: "Roboto Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Roboto-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Roboto-Light.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			9,
			52,
			54,
			56
		]
	},
	{
		name: "Roboto",
		fontFile: "Roboto-Regular",
		family: "Roboto",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Roboto-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Roboto-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			9,
			52,
			54,
			56
		]
	},
	{
		name: "Roboto Mono",
		fontFile: "RobotoMono-Bold",
		family: "Roboto Mono",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/RobotoMono-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/RobotoMono-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			9,
			52,
			54
		]
	},
	{
		name: "Roboto Mono",
		fontFile: "RobotoMono-Italic",
		family: "Roboto Mono",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/RobotoMono-Italic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/RobotoMono-Italic.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			9,
			52,
			54
		]
	},
	{
		name: "Roboto Mono",
		fontFile: "RobotoMono-Light",
		family: "Roboto Mono Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/RobotoMono-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/RobotoMono-Light.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			9,
			52,
			54
		]
	},
	{
		name: "Roboto Mono",
		fontFile: "RobotoMono-Regular",
		family: "Roboto Mono",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/RobotoMono-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/RobotoMono-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			9,
			52,
			54
		]
	},
	{
		name: "Roboto Slab",
		fontFile: "RobotoSlab-Bold",
		family: "Roboto Slab",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/RobotoSlab-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/RobotoSlab-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			6,
			7,
			8,
			9,
			52,
			54
		]
	},
	{
		name: "Roboto Slab",
		fontFile: "RobotoSlab-Light",
		family: "Roboto Slab Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/RobotoSlab-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/RobotoSlab-Light.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			6,
			7,
			8,
			9,
			52,
			54
		]
	},
	{
		name: "Roboto Slab",
		fontFile: "RobotoSlab-Regular",
		family: "Roboto Slab",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/RobotoSlab-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/RobotoSlab-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			6,
			7,
			8,
			9,
			52,
			54
		]
	},
	{
		name: "Roboto Slab",
		fontFile: "RobotoSlab-Thin",
		family: "Roboto Slab Thin",
		weight: "Thin",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/RobotoSlab-Thin.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/RobotoSlab-Thin.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			6,
			7,
			8,
			9,
			52,
			54
		]
	},
	{
		name: "Ropa Sans",
		fontFile: "RopaSans-Regular",
		family: "Ropa Sans",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/RopaSans-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/RopaSans-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "RotisSansSerif",
		fontFile: "RotisSansSerif-Bold",
		family: "RotisSansSerif",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/RotisSansSerif-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/RotisSansSerif-Bold.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "RotisSansSerif",
		fontFile: "RotisSansSerif",
		family: "RotisSansSerif",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/RotisSansSerif.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/RotisSansSerif.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Rozha One",
		fontFile: "RozhaOne-Regular",
		family: "Rozha One",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/RozhaOne-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/RozhaOne-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			16,
			54
		]
	},
	{
		name: "Rubik",
		fontFile: "Rubik-Regular",
		family: "Rubik",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Rubik-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Rubik-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			8,
			11,
			55,
			111
		]
	},
	{
		name: "Rubik One",
		fontFile: "RubikOne-Regular",
		family: "Rubik One",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/RubikOne-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/RubikOne-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			8,
			11,
			55,
			111
		]
	},
	{
		name: "Rufina",
		fontFile: "Rufina-Bold",
		family: "Rufina",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Rufina-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Rufina-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Rufina",
		fontFile: "Rufina-Regular",
		family: "Rufina",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Rufina-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Rufina-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Rundschrift",
		fontFile: "runds___",
		family: "Rundschrift",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/runds___.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/runds___.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Rundschrift EF",
		fontFile: "RundschriftEF-Regular",
		family: "RundschriftEF",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/RundschriftEF-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/RundschriftEF-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Sabon LT Std",
		fontFile: "SabonLTStd-Roman",
		family: "Sabon LT Std",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SabonLTStd-Roman.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SabonLTStd-Roman.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Sackers Italian Script",
		fontFile: "SackersItalianScript",
		family: "Sackers Italian Script",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SackersItalianScript.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SackersItalianScript.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Sacramento",
		fontFile: "Sacramento-Regular",
		family: "Sacramento",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Sacramento-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Sacramento-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Sahitya",
		fontFile: "Sahitya-Bold",
		family: "Sahitya",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Sahitya-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Sahitya-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			16,
			54
		]
	},
	{
		name: "Sahitya",
		fontFile: "Sahitya-Regular",
		family: "Sahitya",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Sahitya-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Sahitya-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			16,
			54
		]
	},
	{
		name: "Salah",
		fontFile: "Salah",
		family: "Salah",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Salah.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Salah.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Salah Line",
		fontFile: "SalahLineThin",
		family: "Salah Line Thin",
		weight: "Thin",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SalahLineThin.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SalahLineThin.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Sanchez",
		fontFile: "Sanchez-Regular",
		family: "Sanchez",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Sanchez-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Sanchez-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Sanies Script",
		fontFile: "SaniesScript",
		family: "Sanies Script",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SaniesScript.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SaniesScript.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Sanies Uno",
		fontFile: "SaniesUno",
		family: "Sanies Uno",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SaniesUno.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SaniesUno.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Satisfy",
		fontFile: "Satisfy-Regular",
		family: "Satisfy",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Satisfy-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Satisfy-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Sawarabi Mincho",
		fontFile: "SawarabiMincho-Regular",
		family: "Sawarabi Mincho",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SawarabiMincho-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SawarabiMincho-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			6,
			66,
			67,
			68,
			69,
			73,
			87,
			88,
			89
		]
	},
	{
		name: "Scene Std",
		fontFile: "SceneStd-Light",
		family: "Scene Std",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SceneStd-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SceneStd-Light.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Scene Std",
		fontFile: "SceneStd-Medium",
		family: "Scene Std",
		weight: "Medium",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SceneStd-Medium.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SceneStd-Medium.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Scope One",
		fontFile: "ScopeOne-Regular",
		family: "Scope One",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/ScopeOne-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/ScopeOne-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			54,
			55,
			56
		]
	},
	{
		name: "SeluneClair",
		fontFile: "SeluneClairPetitesCapitales",
		family: "SeluneClair",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SeluneClairPetitesCapitales.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SeluneClairPetitesCapitales.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Siemens Sans",
		fontFile: "SiemensSans-Bold",
		family: "Siemens Sans",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SiemensSans-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SiemensSans-Bold.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			54,
			55
		]
	},
	{
		name: "Siemens Sans",
		fontFile: "SiemensSans-Roman",
		family: "Siemens Sans",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SiemensSans-Roman.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SiemensSans-Roman.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			54,
			55
		]
	},
	{
		name: "Sigmar One",
		fontFile: "SigmarOne-Regular",
		family: "Sigmar One",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SigmarOne-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SigmarOne-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			6,
			52,
			56
		]
	},
	{
		name: "Signika",
		fontFile: "Signika-Bold",
		family: "Signika",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Signika-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Signika-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Signika",
		fontFile: "Signika-Light",
		family: "Signika Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Signika-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Signika-Light.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Signika",
		fontFile: "Signika-Regular",
		family: "Signika",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Signika-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Signika-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Six Caps",
		fontFile: "SixCaps-Regular",
		family: "Six Caps",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SixCaps-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SixCaps-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Slavina Gradient",
		fontFile: "SlavinaGradient",
		family: "Slavina Gradient",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SlavinaGradient.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SlavinaGradient.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Slavina Love",
		fontFile: "SlavinaLove",
		family: "Slavina Love",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SlavinaLove.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SlavinaLove.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Slavina Script",
		fontFile: "SlavinaScript",
		family: "Slavina Script",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SlavinaScript.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SlavinaScript.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Slavina Slant",
		fontFile: "SlavinaSlant",
		family: "Slavina Slant",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SlavinaSlant.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SlavinaSlant.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Sniglet",
		fontFile: "Sniglet-ExtraBold",
		family: "Sniglet",
		weight: "ExtraBold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Sniglet-ExtraBold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Sniglet-ExtraBold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Sniglet",
		fontFile: "Sniglet-Regular",
		family: "Sniglet",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Sniglet-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Sniglet-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Sophisto BGauge",
		fontFile: "SophistoBGauge",
		family: "Sophisto BGauge",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SophistoBGauge.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SophistoBGauge.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Sophisto DGauge",
		fontFile: "SophistoDGauge",
		family: "Sophisto DGauge",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SophistoDGauge.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SophistoDGauge.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Sorts Mill Goudy",
		fontFile: "SortsMillGoudy-Regular",
		family: "Sorts Mill Goudy",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SortsMillGoudy-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SortsMillGoudy-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			54
		]
	},
	{
		name: "SourceHanSansCN-Bold モッチーポップ",
		fontFile: "SourceHanSansCN-Bold",
		family: "Source Han Sans CN",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSansCN-Bold.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSansCN-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			98,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSansCN-ExtraLight 思源黑体",
		fontFile: "SourceHanSansCN-ExtraLight",
		family: "Source Han Sans CN ExtraLight",
		weight: "ExtraLight",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSansCN-ExtraLight.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSansCN-ExtraLight.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			98,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSansCN-Heavy 思源黑体",
		fontFile: "SourceHanSansCN-Heavy",
		family: "Source Han Sans CN Heavy",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSansCN-Heavy.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSansCN-Heavy.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			98,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSansCN-Light 思源黑体",
		fontFile: "SourceHanSansCN-Light",
		family: "Source Han Sans CN Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSansCN-Light.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSansCN-Light.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			98,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSansCN-Medium 思源黑体",
		fontFile: "SourceHanSansCN-Medium",
		family: "Source Han Sans CN Medium",
		weight: "Medium",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSansCN-Medium.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSansCN-Medium.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			98,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSansCN-Normal 思源黑体",
		fontFile: "SourceHanSansCN-Normal",
		family: "Source Han Sans CN Normal",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSansCN-Normal.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSansCN-Normal.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			98,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSansCN-Regular 思源黑体",
		fontFile: "SourceHanSansCN-Regular",
		family: "Source Han Sans CN",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSansCN-Regular.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSansCN-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			98,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSansHK-Bold 思源黑体",
		fontFile: "SourceHanSansHK-Bold",
		family: "Source Han Sans HK",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSansHK-Bold.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSansHK-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSansHK-ExtraLight 思源黑體",
		fontFile: "SourceHanSansHK-ExtraLight",
		family: "Source Han Sans HK ExtraLight",
		weight: "ExtraLight",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSansHK-ExtraLight.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSansHK-ExtraLight.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSansHK-Heavy 思源黑體",
		fontFile: "SourceHanSansHK-Heavy",
		family: "Source Han Sans HK Heavy",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSansHK-Heavy.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSansHK-Heavy.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSansHK-Light 思源黑體",
		fontFile: "SourceHanSansHK-Light",
		family: "Source Han Sans HK Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSansHK-Light.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSansHK-Light.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSansHK-Medium 思源黑體",
		fontFile: "SourceHanSansHK-Medium",
		family: "Source Han Sans HK Medium",
		weight: "Medium",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSansHK-Medium.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSansHK-Medium.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSansHK-Normal 思源黑體",
		fontFile: "SourceHanSansHK-Normal",
		family: "Source Han Sans HK Normal",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSansHK-Normal.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSansHK-Normal.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSansHK-Regular 思源黑體",
		fontFile: "SourceHanSansHK-Regular",
		family: "Source Han Sans HK",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSansHK-Regular.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSansHK-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSansJP-Bold 思源黑體",
		fontFile: "SourceHanSansJP-Bold",
		family: "Source Han Sans JP",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSansJP-Bold.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSansJP-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			110,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSansJP-ExtraLight 源ノ角ゴシック",
		fontFile: "SourceHanSansJP-ExtraLight",
		family: "Source Han Sans JP ExtraLight",
		weight: "ExtraLight",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSansJP-ExtraLight.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSansJP-ExtraLight.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			110,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSansJP-Heavy 源ノ角ゴシック",
		fontFile: "SourceHanSansJP-Heavy",
		family: "Source Han Sans JP Heavy",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSansJP-Heavy.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSansJP-Heavy.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			110,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSansJP-Light 源ノ角ゴシック",
		fontFile: "SourceHanSansJP-Light",
		family: "Source Han Sans JP Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSansJP-Light.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSansJP-Light.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			110,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSansJP-Medium 源ノ角ゴシック",
		fontFile: "SourceHanSansJP-Medium",
		family: "Source Han Sans JP Medium",
		weight: "Medium",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSansJP-Medium.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSansJP-Medium.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			110,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSansJP-Normal 源ノ角ゴシック",
		fontFile: "SourceHanSansJP-Normal",
		family: "Source Han Sans JP Normal",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSansJP-Normal.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSansJP-Normal.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			110,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSansJP-Regular 源ノ角ゴシック",
		fontFile: "SourceHanSansJP-Regular",
		family: "Source Han Sans JP",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSansJP-Regular.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSansJP-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			110,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSansKR-Bold 源ノ角ゴシック",
		fontFile: "SourceHanSansKR-Bold",
		family: "Source Han Sans KR",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSansKR-Bold.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSansKR-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			31,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			105,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSansKR-ExtraLight 본고딕",
		fontFile: "SourceHanSansKR-ExtraLight",
		family: "Source Han Sans KR ExtraLight",
		weight: "ExtraLight",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSansKR-ExtraLight.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSansKR-ExtraLight.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			31,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			105,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSansKR-Heavy 본고딕",
		fontFile: "SourceHanSansKR-Heavy",
		family: "Source Han Sans KR Heavy",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSansKR-Heavy.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSansKR-Heavy.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			31,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			105,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSansKR-Light 본고딕",
		fontFile: "SourceHanSansKR-Light",
		family: "Source Han Sans KR Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSansKR-Light.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSansKR-Light.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			31,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			105,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSansKR-Medium 본고딕",
		fontFile: "SourceHanSansKR-Medium",
		family: "Source Han Sans KR Medium",
		weight: "Medium",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSansKR-Medium.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSansKR-Medium.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			31,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			105,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSansKR-Normal 본고딕",
		fontFile: "SourceHanSansKR-Normal",
		family: "Source Han Sans KR Normal",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSansKR-Normal.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSansKR-Normal.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			31,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			105,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSansKR-Regular 본고딕",
		fontFile: "SourceHanSansKR-Regular",
		family: "Source Han Sans KR",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSansKR-Regular.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSansKR-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			31,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			105,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSansTW-Bold 본고딕",
		fontFile: "SourceHanSansTW-Bold",
		family: "Source Han Sans TW",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSansTW-Bold.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSansTW-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSansTW-ExtraLight 思源黑體",
		fontFile: "SourceHanSansTW-ExtraLight",
		family: "Source Han Sans TW ExtraLight",
		weight: "ExtraLight",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSansTW-ExtraLight.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSansTW-ExtraLight.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSansTW-Light 思源黑體",
		fontFile: "SourceHanSansTW-Light",
		family: "Source Han Sans TW Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSansTW-Light.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSansTW-Light.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSansTW-Medium 思源黑體",
		fontFile: "SourceHanSansTW-Medium",
		family: "Source Han Sans TW Medium",
		weight: "Medium",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSansTW-Medium.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSansTW-Medium.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSansTW-Normal 思源黑體",
		fontFile: "SourceHanSansTW-Normal",
		family: "Source Han Sans TW Normal",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSansTW-Normal.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSansTW-Normal.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSansTW-Regular 思源黑體",
		fontFile: "SourceHanSansTW-Regular",
		family: "Source Han Sans TW",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSansTW-Regular.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSansTW-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSerifCN-Bold 思源黑體",
		fontFile: "SourceHanSerifCN-Bold",
		family: "Source Han Serif CN",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSerifCN-Bold.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSerifCN-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			98,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSerifCN-ExtraLight 思源黑体",
		fontFile: "SourceHanSerifCN-ExtraLight",
		family: "Source Han Serif CN ExtraLight",
		weight: "ExtraLight",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSerifCN-ExtraLight.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSerifCN-ExtraLight.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			98,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSerifCN-Heavy 思源黑体",
		fontFile: "SourceHanSerifCN-Heavy",
		family: "Source Han Serif CN Heavy",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSerifCN-Heavy.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSerifCN-Heavy.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			98,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSerifCN-Light 思源黑体",
		fontFile: "SourceHanSerifCN-Light",
		family: "Source Han Serif CN Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSerifCN-Light.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSerifCN-Light.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			98,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSerifCN-Medium 思源黑体",
		fontFile: "SourceHanSerifCN-Medium",
		family: "Source Han Serif CN Medium",
		weight: "Medium",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSerifCN-Medium.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSerifCN-Medium.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			98,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSerifCN-Regular 思源黑体",
		fontFile: "SourceHanSerifCN-Regular",
		family: "Source Han Serif CN",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSerifCN-Regular.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSerifCN-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			98,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSerifCN-SemiBold 思源黑体",
		fontFile: "SourceHanSerifCN-SemiBold",
		family: "Source Han Serif CN SemiBold",
		weight: "SemiBold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSerifCN-SemiBold.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSerifCN-SemiBold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			98,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSerifHK-Bold 思源黑体",
		fontFile: "SourceHanSerifHK-Bold",
		family: "Source Han Serif HK",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSerifHK-Bold.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSerifHK-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSerifHK-ExtraLight 思源黑體 ",
		fontFile: "SourceHanSerifHK-ExtraLight",
		family: "Source Han Serif HK ExtraLight",
		weight: "ExtraLight",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSerifHK-ExtraLight.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSerifHK-ExtraLight.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSerifHK-Heavy 思源黑體 ",
		fontFile: "SourceHanSerifHK-Heavy",
		family: "Source Han Serif HK Heavy",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSerifHK-Heavy.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSerifHK-Heavy.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSerifHK-Light 思源黑體 ",
		fontFile: "SourceHanSerifHK-Light",
		family: "Source Han Serif HK Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSerifHK-Light.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSerifHK-Light.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSerifHK-Medium 思源黑體 ",
		fontFile: "SourceHanSerifHK-Medium",
		family: "Source Han Serif HK Medium",
		weight: "Medium",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSerifHK-Medium.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSerifHK-Medium.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSerifHK-Regular 思源黑體 ",
		fontFile: "SourceHanSerifHK-Regular",
		family: "Source Han Serif HK",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSerifHK-Regular.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSerifHK-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSerifHK-SemiBold 思源黑體 ",
		fontFile: "SourceHanSerifHK-SemiBold",
		family: "Source Han Serif HK SemiBold",
		weight: "SemiBold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSerifHK-SemiBold.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSerifHK-SemiBold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSerifJP-Bold 思源黑體 ",
		fontFile: "SourceHanSerifJP-Bold",
		family: "Source Han Serif JP",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSerifJP-Bold.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSerifJP-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			110,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSerifJP-ExtraLight 源ノ角ゴシック ",
		fontFile: "SourceHanSerifJP-ExtraLight",
		family: "Source Han Serif JP ExtraLight",
		weight: "ExtraLight",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSerifJP-ExtraLight.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSerifJP-ExtraLight.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			110,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSerifJP-Heavy 源ノ角ゴシック ",
		fontFile: "SourceHanSerifJP-Heavy",
		family: "Source Han Serif JP Heavy",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSerifJP-Heavy.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSerifJP-Heavy.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			110,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSerifJP-Light 源ノ角ゴシック ",
		fontFile: "SourceHanSerifJP-Light",
		family: "Source Han Serif JP Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSerifJP-Light.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSerifJP-Light.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			110,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSerifJP-Medium 源ノ角ゴシック ",
		fontFile: "SourceHanSerifJP-Medium",
		family: "Source Han Serif JP Medium",
		weight: "Medium",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSerifJP-Medium.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSerifJP-Medium.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			110,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSerifJP-Regular 源ノ角ゴシック ",
		fontFile: "SourceHanSerifJP-Regular",
		family: "Source Han Serif JP",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSerifJP-Regular.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSerifJP-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			110,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSerifJP-SemiBold 源ノ角ゴシック ",
		fontFile: "SourceHanSerifJP-SemiBold",
		family: "Source Han Serif JP SemiBold",
		weight: "SemiBold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSerifJP-SemiBold.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSerifJP-SemiBold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			110,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSerifKR-Bold 源ノ角ゴシック ",
		fontFile: "SourceHanSerifKR-Bold",
		family: "Source Han Serif KR",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSerifKR-Bold.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSerifKR-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			31,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			105,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSerifKR-ExtraLight 본고딕 ",
		fontFile: "SourceHanSerifKR-ExtraLight",
		family: "Source Han Serif KR ExtraLight",
		weight: "ExtraLight",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSerifKR-ExtraLight.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSerifKR-ExtraLight.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			31,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			105,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSerifKR-Heavy 본고딕 ",
		fontFile: "SourceHanSerifKR-Heavy",
		family: "Source Han Serif KR Heavy",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSerifKR-Heavy.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSerifKR-Heavy.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			31,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			105,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSerifKR-Light 본고딕 ",
		fontFile: "SourceHanSerifKR-Light",
		family: "Source Han Serif KR Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSerifKR-Light.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSerifKR-Light.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			31,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			105,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSerifKR-Medium 본고딕 ",
		fontFile: "SourceHanSerifKR-Medium",
		family: "Source Han Serif KR Medium",
		weight: "Medium",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSerifKR-Medium.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSerifKR-Medium.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			31,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			105,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSerifKR-Regular 본고딕 ",
		fontFile: "SourceHanSerifKR-Regular",
		family: "Source Han Serif KR",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSerifKR-Regular.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSerifKR-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			31,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			105,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSerifKR-SemiBold 본고딕 ",
		fontFile: "SourceHanSerifKR-SemiBold",
		family: "Source Han Serif KR SemiBold",
		weight: "SemiBold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSerifKR-SemiBold.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSerifKR-SemiBold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			31,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			105,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSerifTW-Bold 본고딕 ",
		fontFile: "SourceHanSerifTW-Bold",
		family: "Source Han Serif TW",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSerifTW-Bold.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSerifTW-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSerifTW-ExtraLight 思源黑體 ",
		fontFile: "SourceHanSerifTW-ExtraLight",
		family: "Source Han Serif TW ExtraLight",
		weight: "ExtraLight",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSerifTW-ExtraLight.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSerifTW-ExtraLight.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSerifTW-Heavy 思源黑體 ",
		fontFile: "SourceHanSerifTW-Heavy",
		family: "Source Han Serif TW Heavy",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSerifTW-Heavy.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSerifTW-Heavy.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSerifTW-Light 思源黑體 ",
		fontFile: "SourceHanSerifTW-Light",
		family: "Source Han Serif TW Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSerifTW-Light.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSerifTW-Light.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSerifTW-Medium 思源黑體 ",
		fontFile: "SourceHanSerifTW-Medium",
		family: "Source Han Serif TW Medium",
		weight: "Medium",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSerifTW-Medium.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSerifTW-Medium.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSerifTW-Regular 思源黑體 ",
		fontFile: "SourceHanSerifTW-Regular",
		family: "Source Han Serif TW",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSerifTW-Regular.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSerifTW-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "SourceHanSerifTW-SemiBold 思源黑體 ",
		fontFile: "SourceHanSerifTW-SemiBold",
		family: "Source Han Serif TW SemiBold",
		weight: "SemiBold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceHanSerifTW-SemiBold.otf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceHanSerifTW-SemiBold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			58,
			59,
			60,
			61,
			65,
			66,
			67,
			68,
			69,
			84,
			85,
			86,
			87,
			88,
			89,
			90,
			91,
			92,
			93,
			94,
			95,
			96,
			97,
			100,
			114,
			116,
			117,
			119,
			146,
			147
		]
	},
	{
		name: "Source Sans Pro",
		fontFile: "SourceSansPro-Regular",
		family: "Source Sans Pro",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SourceSansPro-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SourceSansPro-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			52,
			53,
			54,
			55,
			56,
			59
		]
	},
	{
		name: "Space Mono",
		fontFile: "SpaceMono-Regular",
		family: "Space Mono",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SpaceMono-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SpaceMono-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Special Elite",
		fontFile: "SpecialElite-Regular",
		family: "Special Elite",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SpecialElite-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SpecialElite-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Squada One",
		fontFile: "SquadaOne-Regular",
		family: "Squada One",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SquadaOne-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SquadaOne-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Sriracha",
		fontFile: "Sriracha-Regular",
		family: "Sriracha",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Sriracha-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Sriracha-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			26,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Stalemate",
		fontFile: "Stalemate-Regular",
		family: "Stalemate",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Stalemate-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Stalemate-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Stardos Stencil",
		fontFile: "StardosStencil-Bold",
		family: "Stardos Stencil",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/StardosStencil-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/StardosStencil-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Stardos Stencil",
		fontFile: "StardosStencil-Regular",
		family: "Stardos Stencil",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/StardosStencil-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/StardosStencil-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Sue Ellen Francisco ",
		fontFile: "SueEllenFrancisco-Regular",
		family: "Sue Ellen Francisco ",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/SueEllenFrancisco-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/SueEllenFrancisco-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Suranna",
		fontFile: "Suranna-Regular",
		family: "Suranna",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Suranna-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Suranna-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			22
		]
	},
	{
		name: "Swis721 Cn BT",
		fontFile: "Swiss721-CondensedBT",
		family: "Swis721 Cn BT",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Swiss721-CondensedBT.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Swiss721-CondensedBT.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Tahoma",
		fontFile: "tahoma",
		family: "Tahoma",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/tahoma.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/tahoma.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			11,
			12,
			14,
			26,
			49,
			50,
			51,
			52,
			53,
			54,
			56,
			111,
			115,
			118
		]
	},
	{
		name: "Tangerine",
		fontFile: "Tangerine_Regular",
		family: "Tangerine",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Tangerine_Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Tangerine_Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "TarzanaWide",
		fontFile: "tarzanawide",
		family: "TarzanaWide",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/tarzanawide.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/tarzanawide.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "TarzanaWideBold",
		fontFile: "tarzanawidebold",
		family: "TarzanaWideBold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/tarzanawidebold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/tarzanawidebold.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Taviraj",
		fontFile: "Taviraj-Regular",
		family: "Taviraj",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Taviraj-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Taviraj-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			26,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "TechnoScriptMono",
		fontFile: "techn___",
		family: "TechnoScriptMono",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/techn___.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/techn___.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "TechnoScriptEF",
		fontFile: "TechnoScriptEF-Regular",
		family: "TechnoScriptEF",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/TechnoScriptEF-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/TechnoScriptEF-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Teko",
		fontFile: "Teko-Bold",
		family: "Teko Bold",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Teko-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Teko-Bold.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			16,
			54
		]
	},
	{
		name: "Teko",
		fontFile: "Teko-Light",
		family: "Teko Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Teko-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Teko-Light.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			16,
			54
		]
	},
	{
		name: "Teko",
		fontFile: "Teko-Medium",
		family: "Teko Medium",
		weight: "Medium",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Teko-Medium.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Teko-Medium.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			16,
			54
		]
	},
	{
		name: "Teko",
		fontFile: "Teko-Regular",
		family: "Teko Regular",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Teko-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Teko-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			16,
			54
		]
	},
	{
		name: "Teko",
		fontFile: "Teko-SemiBold",
		family: "Teko Semibold",
		weight: "SemiBold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Teko-SemiBold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Teko-SemiBold.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			16,
			54
		]
	},
	{
		name: "Tempe!",
		fontFile: "Tempe",
		family: "Tempe!",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Tempe.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Tempe.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "TheSans Caps",
		fontFile: "TheSans-Caps",
		family: "TheSans Caps",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/TheSans-Caps.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/TheSans-Caps.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "TheSans",
		fontFile: "TheSans-Plain",
		family: "TheSans",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/TheSans-Plain.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/TheSans-Plain.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "TheSansBold",
		fontFile: "TheSansBold-Plain",
		family: "TheSansBold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/TheSansBold-Plain.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/TheSansBold-Plain.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "TheSansExtraLight",
		fontFile: "TheSansExtraLight-Plain",
		family: "TheSansExtraLight",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/TheSansExtraLight-Plain.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/TheSansExtraLight-Plain.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Times-Roman",
		fontFile: "times",
		family: "Times-Roman",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/times.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/times.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			54,
			66,
			67
		]
	},
	{
		name: "Times New Rom B",
		fontFile: "timesbd",
		family: "Times New Rom B",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/timesbd.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/timesbd.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			54,
			66,
			67
		]
	},
	{
		name: "Titillium Web",
		fontFile: "TitilliumWeb-Bold",
		family: "Titillium Web",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/TitilliumWeb-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/TitilliumWeb-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			55
		]
	},
	{
		name: "Titillium Web",
		fontFile: "TitilliumWeb-Light",
		family: "Titillium Web Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/TitilliumWeb-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/TitilliumWeb-Light.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			55
		]
	},
	{
		name: "Titillium Web",
		fontFile: "TitilliumWeb-Regular",
		family: "Titillium Web",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/TitilliumWeb-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/TitilliumWeb-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			55
		]
	},
	{
		name: "TodaySansBEF-Reg",
		fontFile: "TodayBEF-Regular",
		family: "TodaySansBEF-Reg",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/TodayBEF-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/TodayBEF-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "TodaySansB",
		fontFile: "TodaySans",
		family: "TodaySansB",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/TodaySans.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/TodaySans.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Toyota Text",
		fontFile: "ToyotaText_Bd",
		family: "Toyota Text",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/ToyotaText_Bd.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/ToyotaText_Bd.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			54,
			55,
			59
		]
	},
	{
		name: "TradeGothic LT Bold",
		fontFile: "TradeGothicLT-Bold",
		family: "TradeGothic LT Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/TradeGothicLT-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/TradeGothicLT-Bold.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "TradeGothic LT",
		fontFile: "TradeGothicLT",
		family: "TradeGothic LT",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/TradeGothicLT.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/TradeGothicLT.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Trade Gothic LT Std",
		fontFile: "TradeGothicLTStd-Light",
		family: "Trade Gothic LT Std",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/TradeGothicLTStd-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/TradeGothicLTStd-Light.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Trajan Pro",
		fontFile: "TrajanPro-Bold",
		family: "Trajan Pro",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/TrajanPro-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/TrajanPro-Bold.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Trajan Pro",
		fontFile: "TrajanPro-Regular",
		family: "Trajan Pro",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/TrajanPro-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/TrajanPro-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Trebuchet MS",
		fontFile: "trebuc",
		family: "Trebuchet MS",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/trebuc.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/trebuc.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			54
		]
	},
	{
		name: "Trebuchet MS",
		fontFile: "trebucbd",
		family: "Trebuchet MS",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/trebucbd.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/trebucbd.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			54
		]
	},
	{
		name: "Trip Sans",
		fontFile: "TripSans-Bold",
		family: "Trip Sans",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/TripSans-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/TripSans-Bold.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Trip Sans",
		fontFile: "TripSans-BoldItalic",
		family: "Trip Sans",
		weight: "Bold",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/TripSans-BoldItalic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/TripSans-BoldItalic.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Trip Sans",
		fontFile: "TripSans-Italic",
		family: "Trip Sans",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/TripSans-Italic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/TripSans-Italic.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Trip Sans",
		fontFile: "TripSans-Medium",
		family: "Trip Sans Medium",
		weight: "Medium",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/TripSans-Medium.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/TripSans-Medium.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Trip Sans",
		fontFile: "TripSans-MediumItalic",
		family: "Trip Sans Medium",
		weight: "Medium",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/TripSans-MediumItalic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/TripSans-MediumItalic.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Trip Sans",
		fontFile: "TripSans-Ultra",
		family: "Trip Sans Ultra",
		weight: "ExtraBold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/TripSans-Ultra.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/TripSans-Ultra.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Trip Sans Mono",
		fontFile: "TripSansMono-Regular",
		family: "Trip Sans Mono",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/TripSansMono-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/TripSansMono-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Trip Sans",
		fontFile: "TripSansRegular",
		family: "Trip Sans",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/TripSansRegular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/TripSansRegular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Trocchi",
		fontFile: "Trocchi-Regular",
		family: "Trocchi",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Trocchi-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Trocchi-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3
		]
	},
	{
		name: "Trochut",
		fontFile: "Trochut-Regular",
		family: "Trochut",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Trochut-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Trochut-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Ubuntu",
		fontFile: "Ubuntu-Bold",
		family: "Ubuntu",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Ubuntu-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Ubuntu-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			7,
			8,
			53,
			54,
			55,
			59
		]
	},
	{
		name: "Ubuntu",
		fontFile: "Ubuntu-Light",
		family: "Ubuntu Light",
		weight: "Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Ubuntu-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Ubuntu-Light.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			7,
			8,
			53,
			54,
			55,
			59
		]
	},
	{
		name: "Ubuntu",
		fontFile: "Ubuntu-Regular",
		family: "Ubuntu",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Ubuntu-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Ubuntu-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			7,
			8,
			53,
			54,
			55,
			59
		]
	},
	{
		name: "Ultra",
		fontFile: "Ultra-Regular",
		family: "Ultra",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Ultra-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Ultra-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Underdog",
		fontFile: "Underdog-Regular",
		family: "Underdog",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Underdog-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Underdog-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			8
		]
	},
	{
		name: "Unna",
		fontFile: "Unna-Bold",
		family: "Unna",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Unna-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Unna-Bold.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Unna",
		fontFile: "Unna-Regular",
		family: "Unna",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Unna-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Unna-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "VAGRounded-Bold",
		fontFile: "vaground",
		family: "VAGRounded-Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/vaground.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/vaground.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			54,
			66,
			67
		]
	},
	{
		name: "VAGRounded-Light",
		fontFile: "VAGRounded-Light",
		family: "VAGRounded-Light",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/VAGRounded-Light.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/VAGRounded-Light.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			54,
			66,
			67
		]
	},
	{
		name: "Valledofas second",
		fontFile: "Valledofas_second",
		family: "Valledofas second",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Valledofas_second.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Valledofas_second.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Valledofas",
		fontFile: "Valledofas",
		family: "Valledofas",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Valledofas.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Valledofas.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Vallen",
		fontFile: "Vallen",
		family: "Vallen",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Vallen.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Vallen.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Varela Round",
		fontFile: "VarelaRound-Regular",
		family: "Varela Round",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/VarelaRound-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/VarelaRound-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			3,
			5,
			6,
			11,
			52,
			54,
			55,
			56
		]
	},
	{
		name: "Vast Shadow",
		fontFile: "VastShadow-Regular",
		family: "Vast Shadow",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/VastShadow-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/VastShadow-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Vectora LT Std",
		fontFile: "VectoraLTStd-Bold",
		family: "Vectora LT Std",
		weight: "Bold",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/VectoraLTStd-Bold.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/VectoraLTStd-Bold.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Vectora LT Std",
		fontFile: "VectoraLTStd-Italic",
		family: "Vectora LT Std",
		style: "Italic",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/VectoraLTStd-Italic.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/VectoraLTStd-Italic.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Vectora LT Std",
		fontFile: "VectoraLTStd-Roman",
		family: "Vectora LT Std",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/VectoraLTStd-Roman.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/VectoraLTStd-Roman.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Verdana",
		fontFile: "Verdana",
		family: "Verdana",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Verdana.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Verdana.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			7,
			8,
			52,
			54,
			56
		]
	},
	{
		name: "Vidaloka ",
		fontFile: "Vidaloka-Regular",
		family: "Vidaloka ",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Vidaloka-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Vidaloka-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1
		]
	},
	{
		name: "Wellfleet",
		fontFile: "Wellfleet-Regular",
		family: "Wellfleet",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Wellfleet-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Wellfleet-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Yellowtail",
		fontFile: "Yellowtail-Regular",
		family: "Yellowtail",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Yellowtail-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Yellowtail-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Yeseva One",
		fontFile: "YesevaOne-Regular",
		family: "Yeseva One",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/YesevaOne-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/YesevaOne-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			6,
			8,
			52
		]
	},
	{
		name: "Yesteryear",
		fontFile: "Yesteryear-Regular",
		family: "Yesteryear",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/Yesteryear-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/Yesteryear-Regular.png",
		isPremium: true,
		unicodeBlockIndexes: [
			0,
			1,
			2
		]
	},
	{
		name: "Zilla Slab",
		fontFile: "ZillaSlab-Regular",
		family: "Zilla Slab",
		fileUrl: "https://cdn-adl.gelatogroup.com/api-fonts/ttf/ZillaSlab-Regular.ttf",
		previewUrl: "https://cdn-adl.gelatogroup.com/api-fonts/previews/ZillaSlab-Regular.png",
		isPremium: false,
		unicodeBlockIndexes: [
			0,
			1,
			2,
			54,
			55,
			56
		]
	}
];

var unicodeBlocksJson = [
	[
		0,
		127
	],
	[
		128,
		255
	],
	[
		256,
		383
	],
	[
		384,
		591
	],
	[
		592,
		687
	],
	[
		688,
		767
	],
	[
		768,
		879
	],
	[
		880,
		1023
	],
	[
		1024,
		1279
	],
	[
		1280,
		1327
	],
	[
		1328,
		1423
	],
	[
		1424,
		1535
	],
	[
		1536,
		1791
	],
	[
		1792,
		1871
	],
	[
		1872,
		1919
	],
	[
		1920,
		1983
	],
	[
		2304,
		2431
	],
	[
		2432,
		2559
	],
	[
		2560,
		2687
	],
	[
		2688,
		2815
	],
	[
		2816,
		2943
	],
	[
		2944,
		3071
	],
	[
		3072,
		3199
	],
	[
		3200,
		3327
	],
	[
		3328,
		3455
	],
	[
		3456,
		3583
	],
	[
		3584,
		3711
	],
	[
		3712,
		3839
	],
	[
		3840,
		4095
	],
	[
		4096,
		4255
	],
	[
		4256,
		4351
	],
	[
		4352,
		4607
	],
	[
		4608,
		4991
	],
	[
		4992,
		5023
	],
	[
		5024,
		5119
	],
	[
		5120,
		5759
	],
	[
		5760,
		5791
	],
	[
		5792,
		5887
	],
	[
		5888,
		5919
	],
	[
		5920,
		5951
	],
	[
		5952,
		5983
	],
	[
		5984,
		6015
	],
	[
		6016,
		6143
	],
	[
		6144,
		6319
	],
	[
		6400,
		6479
	],
	[
		6480,
		6527
	],
	[
		6528,
		6623
	],
	[
		6624,
		6655
	],
	[
		6656,
		6687
	],
	[
		7424,
		7551
	],
	[
		7552,
		7615
	],
	[
		7616,
		7679
	],
	[
		7680,
		7935
	],
	[
		7936,
		8191
	],
	[
		8192,
		8303
	],
	[
		8304,
		8351
	],
	[
		8352,
		8399
	],
	[
		8400,
		8447
	],
	[
		8448,
		8527
	],
	[
		8528,
		8591
	],
	[
		8592,
		8703
	],
	[
		8704,
		8959
	],
	[
		8960,
		9215
	],
	[
		9216,
		9279
	],
	[
		9280,
		9311
	],
	[
		9312,
		9471
	],
	[
		9472,
		9599
	],
	[
		9600,
		9631
	],
	[
		9632,
		9727
	],
	[
		9728,
		9983
	],
	[
		9984,
		10175
	],
	[
		10176,
		10223
	],
	[
		10224,
		10239
	],
	[
		10240,
		10495
	],
	[
		10496,
		10623
	],
	[
		10624,
		10751
	],
	[
		10752,
		11007
	],
	[
		11008,
		11263
	],
	[
		11264,
		11359
	],
	[
		11392,
		11519
	],
	[
		11520,
		11567
	],
	[
		11568,
		11647
	],
	[
		11648,
		11743
	],
	[
		11776,
		11903
	],
	[
		11904,
		12031
	],
	[
		12032,
		12255
	],
	[
		12272,
		12287
	],
	[
		12288,
		12351
	],
	[
		12352,
		12447
	],
	[
		12448,
		12543
	],
	[
		12544,
		12591
	],
	[
		12592,
		12687
	],
	[
		12688,
		12703
	],
	[
		12704,
		12735
	],
	[
		12736,
		12783
	],
	[
		12784,
		12799
	],
	[
		12800,
		13055
	],
	[
		13056,
		13311
	],
	[
		13312,
		19903
	],
	[
		19904,
		19967
	],
	[
		19968,
		40959
	],
	[
		40960,
		42127
	],
	[
		42128,
		42191
	],
	[
		42752,
		42783
	],
	[
		43008,
		43055
	],
	[
		44032,
		55215
	],
	[
		55296,
		56191
	],
	[
		56192,
		56319
	],
	[
		56320,
		57343
	],
	[
		57344,
		63743
	],
	[
		63744,
		64255
	],
	[
		64256,
		64335
	],
	[
		64336,
		65023
	],
	[
		65024,
		65039
	],
	[
		65040,
		65055
	],
	[
		65056,
		65071
	],
	[
		65072,
		65103
	],
	[
		65104,
		65135
	],
	[
		65136,
		65279
	],
	[
		65280,
		65519
	],
	[
		65520,
		65535
	],
	[
		65536,
		65663
	],
	[
		65664,
		65791
	],
	[
		65792,
		65855
	],
	[
		65856,
		65935
	],
	[
		65936,
		65999
	],
	[
		66000,
		66047
	],
	[
		66176,
		66207
	],
	[
		66208,
		66271
	],
	[
		66304,
		66351
	],
	[
		66352,
		66383
	],
	[
		66432,
		66463
	],
	[
		66464,
		66527
	],
	[
		66560,
		66639
	],
	[
		66640,
		66687
	],
	[
		66688,
		66735
	],
	[
		67584,
		67647
	],
	[
		68096,
		68191
	],
	[
		118784,
		119039
	],
	[
		119040,
		119295
	],
	[
		119296,
		119375
	],
	[
		119552,
		119647
	],
	[
		119808,
		120831
	],
	[
		126976,
		127023
	],
	[
		127024,
		127135
	],
	[
		127136,
		127231
	],
	[
		127232,
		127487
	],
	[
		127488,
		127743
	],
	[
		127744,
		128511
	],
	[
		128512,
		128591
	],
	[
		128640,
		128767
	],
	[
		128768,
		128895
	],
	[
		128896,
		129023
	],
	[
		129024,
		129279
	],
	[
		129280,
		129535
	],
	[
		129536,
		129647
	],
	[
		131072,
		173791
	],
	[
		194560,
		195103
	],
	[
		917504,
		917631
	],
	[
		917760,
		917999
	],
	[
		983040,
		1048575
	],
	[
		1048576,
		1114111
	]
];

function weightToCSSWeight(weight) {
    switch (weight) {
        case 'Thin': return '100';
        case 'ExtraLight': return '200';
        case 'Light': return '300';
        case 'Regular': return '400';
        case 'Medium': return '500';
        case 'Bold': return '600';
        case 'SemiBold': return '700';
        case 'ExtraBold': return '800';
        case 'Black': return '900';
        default: return 'normal';
    }
}
function styleToCSSStyle(weight) {
    switch (weight) {
        case 'Italic': return 'italic';
        default: return 'normal';
    }
}

var popularFontsListJson = [
	"Roboto-Regular",
	"OpenSans-Regular",
	"Montserrat-Regular",
	"Lato-Regular",
	"Oswald-Regular",
	"Raleway-Regular",
	"NotoSans-Regular",
	"Nunito-Regular",
	"RobotoSlab-Regular",
	"PlayfairDisplay-Regular"
];

var embroideryFontsListJson = [
	"NotoSerif-Bold",
	"FiraSans-Regular",
	"ZillaSlab-Regular",
	"Pacifico-Regular",
	"Oswald-Bold",
	"NotoSansMono-Bold",
	"Lobster-Regular",
	"ArbutusSlab-Regular",
	"StardosStencil-Regular"
];

const fontList = fontListJson;
const popularFontList = popularFontsListJson;
const embroideryFontList = embroideryFontsListJson;
const unicodeBlocks = unicodeBlocksJson;

exports.embroideryFontList = embroideryFontList;
exports.fontList = fontList;
exports.popularFontList = popularFontList;
exports.styleToCSSStyle = styleToCSSStyle;
exports.unicodeBlocks = unicodeBlocks;
exports.weightToCSSWeight = weightToCSSWeight;
